<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'HomeView',
})
</script>
<template>
  <DM ref="dm" />
  <!-- 触发按钮：点击打开编辑器 -->
  <!-- <a-button @click="openSqlExecuteEditor" type="primary" style="margin-left: 8px"> 打开SQL执行编辑器 </a-button> -->
  <a-modal v-model:open="sqlExecuteModal.isVisible" title="执行 SQL 脚本" width="600px" :mask-closable="false" :footer="null">
    <FrmExcuteEditorSQL
      ref="(el) => sqlExecuteModal.editorRef = el"
      :visible="sqlExecuteModal.isVisible"
      :item-code="sqlExecuteModal.itemCode"
      :parameters="sqlExecuteModal.initParams"
      @close="handleSqlExecuteClose"
    />
  </a-modal>
    <!-- 关键：挂载查找替换组件（必须加！） -->

  <SqlHelpModal v-model:open="openSqlHelpModal" />
  <!-- @confirm="handleSqlHelpConfirm" -->
  <a-modal v-model:open="sqlModal.isVisible" :title="sqlModal.title" width="80%" :mask-closable="false" :closable="true" :footer="null">
    <div class="sql-modal-content">
      <!-- 工具栏 -->
      <Toolbar bordered :leftItems="sqlEditTools" @menu-click="handleSqlToolbarMenuClick" />
        <ContextMenu
          :menuItems="contextMenuItems2"
          @menu-click="handleContextMenuClick3"
          
          :current-row="currentRow"
          v-model:visible="isContextMenuShow"
          :style="{
            position: 'absolute',
            left: contextMenuX + 'px',
            top: contextMenuY + 'px',
            zIndex: 9999
          }"
        />
      <!-- 项目名称输入框 -->
      <a-input v-model:value="sqlEditForm.item_name" placeholder="请输入项目描述" @keydown="handleInputKeydown" >
        <template #prefix>
          <Icon name="BookOutlined" size="16" color="#666" />
        </template>
        <template #suffix>
          <a-tooltip title="项目描述用于描述脚本功能">
            <!-- <UserOutlined style="color: rgba(0, 0, 0, 0.45)" /> -->
          </a-tooltip>
        </template>
      </a-input>

      <!-- CodeMirror 编辑器（带全屏功能） -->
      <div class="sql-editor-wrapper" ref="editorWrapper">
        <Codemirror
          autoRefresh="true"
          id="cm_sql_editor"
          name="cm_sql"
          border
          v-model:value="sqlEditForm.sql_script"
          :options="sqlCmOptions"
          @ready="handleSqlCmReady"
          
          :style="{ height: sqlEditorHeight }" 
          ref="sqlCmRef1"
        />
          <SqlFindReplace 
    v-model:visible="showFindReplace"
    :editor-instance="sqlCmInstance"
  />
        <!-- @keydown="sqlEditForm.SqlChanged = true" -->
        <!-- 右键菜单 -->

      </div>
    </div>
  </a-modal>

  <!-- 主页面布局 -->
  <a-layout style="height: calc(100vh - 80px)">
    <a-layout style="height: 70vh">
      <!-- 上栏：工具栏+表格 -->
      <a-layout-content :style="contentStyle">
        <Toolbar bordered :leftItems="leftTools" @menu-click="handleToolbarMenuClick" />
        <ContextMenu :menuItems="contextMenuItems" @menu-click="handleContextMenuClick" :current-row="currentRow" triggerTarget=".click-to-open-menu"  />
        <a-table
          :columns="columns"
          :data-source="tableData"
          :scroll="{ x: `${columns.length}0%`, y: 'calc(70vh - 40px - 24px - 16px)' }"
          :header-cell-style="{ textAlign: 'center', position: 'sticky', top: 0 }"
          virtual-scroll
          size="small"
          style="width: 100%; max-height: 100%; min-height: 100%"
          bordered
          class="custom-table click-to-open-menu"
          :pagination="false"
          :custom-row="customRow"
        />
      </a-layout-content>
    </a-layout>

    <!-- 下栏：底部编辑器 -->
    <a-layout-content :style="bottomContentStyle">
      <!-- <ContextMenu :menuItems="contextMenuItems" @menu-click="handleContextMenuClick" :current-row="currentRow" triggerTarget=".click-to-open-menu" v-model="isContextMenuShow" /> -->
      <Codemirror autoRefresh="true" id="cm1" name="cm1" border :value="code" :options="cmOptions" @ready="onReady" style="width: 100%" :height="'calc(30vh - 89px)'" ref="cmRef1"   

      />
    </a-layout-content>
  </a-layout>
</template>

<script setup lang="ts" name="HomeView">
// 基础导入
import { ref, h, reactive, onMounted, nextTick, computed, onUnmounted } from 'vue'
import { Modal, Select, Tooltip, message, Checkbox, Input, DatePicker } from 'ant-design-vue'
const { Option } = Select
import screenfull from 'screenfull'

// 编辑器相关
import Codemirror from 'codemirror-editor-vue3'
import 'codemirror/lib/codemirror.css'
import 'codemirror/theme/idea.css'
import 'codemirror/addon/hint/show-hint.css'
import type { Editor } from 'codemirror'



// 自定义组件与工具
import ContextMenu from '@/components/Menu/ContextMenu.vue'
import Toolbar from '@/components/Menu/Toolbar.vue'
import type { ToolbarItemProps } from '@/components/Menu/Toolbar.vue'
import DM from '@/utils/dm.vue'
import f, { sysInfo } from '@/utils/f.ts'
import dayjs from 'dayjs'
import type { UnwrapRef } from 'vue'
import ALayout from 'ant-design-vue/es/layout'
import FrmExcuteEditorSQL from '@/components/Common/FrmExcuteEditorSQL.vue'
import Icon, { icon } from '@/components/Common/Icon'
import SqlHelpModal from './components/SqlHelpModal.vue'
import SqlFindReplace from './components/SqlFindReplace.vue'
// 编辑器容器ref（核心：和模板中的ref="editorWrapper"对应）
const editorWrapper = ref<HTMLDivElement | null>(null)
const openSqlHelpModal = ref(false)
import { color } from 'echarts'
const contextMenuX = ref(0) // 菜单X坐标
const contextMenuY = ref(0) // 菜单Y坐标
// 脚本中新增 Codemirror keydown 处理方法（阻止事件透传/仅内部处理）
const showFindReplace = ref<boolean>(false)  // 控制查找替换弹窗显隐
// SQL编辑器实例与状态
const sqlCmRef1 = ref(null)
const sqlCmInstance = ref<Editor | null>(null)
const isSqlEditorFullScreen = ref(false)  
const modalConfig = {
  width: '80%',
  maskClosable: false,
  closable: false,
  footer: null,
  // 新增高度相关配置
  maxHeight: '85vh', // 弹窗最大高度（适配视口，避免超出屏幕）
  contentHeight: computed(() => {
    // 同步a-modal内部内容的高度计算逻辑（和你的SQL编辑器高度对齐）
    return 'calc(70vh - 145px)'; 
  })
};

// 新增：动态计算编辑器高度（适配全屏/非全屏）
const sqlEditorHeight = computed(() => {
  // 全屏状态：占满全屏视口（减去标题栏/工具栏高度）
  if (isSqlEditorFullScreen.value && screenfull.isFullscreen) {
    return 'calc(100vh - 80px)' // 80px 预留标题栏+工具栏高度，可根据实际调整
  }
  // 非全屏状态：保留原有高度逻辑
  return 'calc(70vh - 145px)'
})



// 生命周期：卸载时移除监听（避免内存泄漏）
onUnmounted(() => {
  const cm = sqlCmRef1.value?.cm
  if (cm) {
    const editorDom = cm.getWrapperElement()
    editorDom.removeEventListener('contextmenu', handleEditorContextMenu)
  }
  document.removeEventListener('click', handleGlobalClick)
})
// 全局点击关闭菜单（点击其他区域隐藏右键菜单）
const handleGlobalClick = (e: MouseEvent) => {
  const target = e.target as HTMLElement
  
  // 仅判断是否点击菜单外区域，不拦截事件
  if (!target.closest('.context-menu') && isContextMenuShow.value) {
    isContextMenuShow.value = false

    // 全屏时，隐藏菜单后强制重置高度（核心！）
    if (screenfull.isEnabled && screenfull.isFullscreen) {
      nextTick(() => {
        const cmDom = document.getElementById('cm_sql_editor')
        if (cmDom) cmDom.style.height = 'calc(100vh - 80px)'
        if (sqlCmInstance.value) {
          sqlCmInstance.value.setSize('100%', 'calc(100vh - 80px)')
        }
      })
    }
  }
}

// ======================== 修复后的 Ctrl+D 快捷键处理函数 ========================
const handleInputKeydown = async (e: KeyboardEvent) => {
  // 判断Ctrl+D（兼容Mac的Cmd+D）
  if ((e.ctrlKey || e.metaKey) && e.key === 'd') {
    e.preventDefault() // 阻止浏览器默认行为

    try {
      // 1. 读取剪贴板内容（兼容低版本浏览器）
      let jsonText = ''
      try {
        // 现代浏览器Clipboard API
        jsonText = await navigator.clipboard.readText()
      } catch (clipboardErr) {
        // 降级方案：使用execCommand（兼容IE/旧版Chrome）
        const textArea = document.createElement('textarea')
        textArea.style.position = 'fixed'
        textArea.style.opacity = '0'
        document.body.appendChild(textArea)
        textArea.focus()
        textArea.select()
        try {
          document.execCommand('paste')
          jsonText = textArea.value
        } catch (err) {
          f.error('浏览器不支持剪贴板读取，请手动复制JSON内容')
          return
        } finally {
          document.body.removeChild(textArea)
        }
      }

      if (!jsonText) {
        f.warning('剪贴板为空，请先执行【脚本打包】操作！')
        return
      }

      // 2. 预处理JSON（修复转义问题）
      // 移除可能的首尾空格/换行，修复JSON转义
      jsonText = jsonText.trim()
      // 处理JSON中的转义双引号（如果有）
      jsonText = jsonText.replace(/\\"/g, '"')

      // 3. 校验是否为打包格式
      if (!jsonText.includes('CopySingSQLHead')) {
        f.warning('剪切板内容格式不符，请先操作【脚本打包】到剪切板！')
        console.log('当前剪贴板内容：', jsonText) // 调试用
        return
      }

      // 4. 解析JSON（强力容错）
      let packData: any
      try {
        // 方案1：直接解析
        packData = JSON.parse(jsonText)
      } catch (parseErr) {
        // 方案2：修复JSON格式后重试（处理未转义的换行符）
        try {
          const fixedJson = jsonText
            .replace(/(\r\n|\n|\r)/g, '\\n') // 替换换行符为转义符
            .replace(/([\u0000-\u0019])/g, '') // 移除不可见字符
          packData = JSON.parse(fixedJson)
        } catch (fixedErr) {
          f.error('JSON解析失败：' + (fixedErr as Error).message)
          console.error('原始JSON：', jsonText)
          console.error('解析错误：', fixedErr)
          return
        }
      }

      // 5. 校验解析后的数据结构
      if (!packData || typeof packData !== 'object') {
        f.error('剪贴板数据解析后不是有效对象！')
        return
      }

      // 6. 精准赋值到表单（完整字段映射）
      // SQL脚本：移除开头的换行符，保留原始格式
      sqlEditForm.sql_script = packData.SQLScript ? packData.SQLScript.replace(/^[\r\n]+/, '') : ''
      // 项目名称
      sqlEditForm.item_name = packData.ItemName || ''
      // 数据库名称
      sqlEditForm.db_name = packData.DBName || 'SYS'
      // 可选：赋值ItemCode（如需覆盖新增的SN）
      // if (packData.ItemCode) {
      //   sqlEditForm.item_code = packData.ItemCode;
      //   sqlModal.title = '新增脚本 ' + packData.ItemCode;
      // }
      // 其他字段（按需赋值）
      if (packData.NeedUpdate) {
        // 如需显示NeedUpdate，可在sqlEditForm中新增该字段
        // sqlEditForm.NeedUpdate = packData.NeedUpdate;
      }

      // 7. 强制刷新编辑器
      nextTick(() => {
        if (sqlCmInstance.value) {
          sqlCmInstance.value.setValue(sqlEditForm.sql_script)
          sqlCmInstance.value.refresh()
        }
      })

      // f.success(`已成功加载：${packData.ItemName || 'SQL脚本'}`);
    } catch (err) {
      const error = err as Error
      if (error.message.includes('NotAllowed')) {
        f.error('请允许浏览器访问剪贴板权限（设置→网站设置→剪贴板）')
      } else {
        f.error('处理剪贴板失败：' + error.message)
      }
      console.error('Ctrl+D完整错误：', err)
    }
  }else if  ((e.ctrlKey || e.metaKey) && e.key === 'f') {
    e.preventDefault()
    showFindReplace.value = true
  }
}

// ======================== 原有页面变量 ========================
const placement = ref<string>('right')
const visible = ref<boolean>(false)
// 执行SQL编辑器的配置（唯一数据源，避免混乱）
const sqlExecuteModal = reactive({
  isVisible: false, // 控制编辑器弹窗显示/隐藏
  itemCode: '', // 传给编辑器的itemCode
  initParams: {} as Record<string, any>, // 传给编辑器的参数
  editorRef: null as UnwrapRef<typeof FrmExcuteEditorSQL> | null // 编辑器组件引用
})

// 2. 打开执行SQL编辑器（触发按钮调用这个方法）
// const openSqlExecuteEditor = () => {
//     // 1. 判断关键参数是否为空
//   if (!currentRow.ItemCode ) {
//     // 弹出提示：具体提示文字可根据实际需求调整
//     message.warning('请先选择要执行的 SQL 脚本！');
//     return; // 终止后续操作，不打开编辑器
//   }
//   sqlExecuteModal.itemCode = 'SQLScript_2112010003' //currentRow.item_code// 你的固定itemCode
//   // 可以在这里给编辑器传额外参数（比如当前选中的数据库名）
//   sqlExecuteModal.initParams = {
//     DBName: sqlEditForm.db_name // 从sqlEditForm获取当前数据库名，传给编辑器
//     // 其他需要给编辑器的参数...
//   }
//   sqlExecuteModal.isVisible = true // 显示编辑器弹窗
// }

// 3. 关闭编辑器的回调（接收编辑器的执行结果）
const handleSqlExecuteClose = (success: boolean) => {
  sqlExecuteModal.isVisible = false
  if (success) {
    // message.success('SQL执行成功！')
    sqlEditForm.SqlChanged = false // 同步表单状态
    // 执行成功后的后续处理（比如刷新数据）
    // search();
  } else {
    message.warning('SQL执行取消或失败')
  }
}
// 样式配置
const contentStyle: CSSProperties = {
  minHeight: 'auto'
  // backgroundColor: '#108ee9',
}
const bottomContentStyle: CSSProperties = {
  backgroundColor: '#f5f5f5',
  overflow: 'auto'
}

// SQL执行弹窗（原有）
const sqlModal = reactive({
  isVisible: false,
  title: '执行 SQL 脚本',
  itemCode: '',
  editorRef: null as UnwrapRef<typeof FrmExcuteEditorSQL> | null,
  initParams: {} as Record<string, any>
})

// 表格数据相关
interface TableRowData {
  ItemCode: string
  ItemName: string
  DBName: string
  EditTime: string
  SQLScript: string
  [key: string]: any
}
interface ContextMenuItem {
  key?: string
  label: string
  icon?: any
  children?: ContextMenuItem[]
  disabled?: boolean
}

const allTableData = ref<TableRowData[]>([])
const pageSize = ref(10)
const dm = ref(null)
const currentRow = ref<TableRowData | null>(null)
const current = ref(1)
let code = ref(``)
const cmRef1 = ref(null)
const isContextMenuShow = ref(false)
// 生命周期：挂载时监听全局点击
onMounted(() => {
  document.addEventListener('click', handleGlobalClick)
})

// 表格计算属性
const tableData = computed(() => {
  const data = allTableData.value || []
  const start = (current.value - 1) * pageSize.value
  const end = start + pageSize.value
  return data
})

// 编辑器全屏切换
// 编辑器全屏切换（核心修改）
const sql_full_screen = () => {
  if (!screenfull.isEnabled) {
    message.warning('您的浏览器不支持全屏功能')
    return
  }

  // 关键1：获取整个内容容器（而非仅编辑器）
  const contentDom = document.querySelector('.sql-modal-content')
  if (!contentDom) {
    message.error('未找到弹窗内容容器')
    return
  }

  try {
    
    if (isSqlEditorFullScreen.value) {
      screenfull.exit()
      // 退出全屏后恢复原有尺寸
      const cmDom = document.getElementById('cm_sql_editor')
      if (cmDom) cmDom.style.height = 'calc(70vh - 145px)'
      sqlCmInstance.value?.refresh()
    } else {
      // 关键2：请求整个内容容器全屏
      screenfull.request(contentDom)
      // 全屏后自适应编辑器高度
      const cmDom = document.getElementById('cm_sql_editor')
      if (cmDom) cmDom.style.height = 'calc(100vh - 120px)' // 预留Toolbar和input高度
      sqlCmInstance.value?.refresh()
    }
    isSqlEditorFullScreen.value = !isSqlEditorFullScreen.value
  } catch (error) {
    message.error('全屏操作失败：' + error.message)
    console.error('全屏错误：', error)
  }
}
// 关闭SQL编辑弹窗
const handleSqlModalClose = () => {
  // 增强：强制退出全屏（不管当前全屏的是哪个元素）
if (screenfull.isEnabled && screenfull.isFullscreen) {
  // 1. 先执行退出全屏（异步操作）
  screenfull.exit()
  
  // 2. 监听全屏状态变化，确保退出完成后再重置高度
  const onFullscreenChange = () => {
    if (!screenfull.isFullscreen) { // 确认已退出全屏
      isSqlEditorFullScreen.value = false
      // 此时视口已恢复，计算尺寸才准确
      const cmDom = document.getElementById('cm_sql_editor')
      if (cmDom) {
        cmDom.style.height = 'calc(70vh - 145px)'
        // 额外：清空全屏时可能设置的min/maxHeight
        cmDom.style.minHeight = ''
        cmDom.style.maxHeight = ''
      }
      sqlCmInstance.value?.setSize('100%', 'calc(70vh - 145px)')
      sqlCmInstance.value?.refresh()
      
      // 移除一次性监听，避免内存泄漏
      screenfull.off('change', onFullscreenChange)
    }
  }
  
  // 3. 绑定一次性监听事件
  screenfull.on('change', onFullscreenChange)
}


  if (sqlEditForm.SqlChanged) {
    Modal.confirm({
      title: '确认关闭',
      content: '是否确定关闭？未保存的内容将丢失',      onOk: () => {
        sqlModal.isVisible = false
        sqlEditForm.SqlChanged = false
      }
    })
  } else {
    sqlModal.isVisible = false
  }
}
// 执行SQL脚本
const sql_run = () => {
  // sqlExecuteModal.itemCode='SQLScript_2112010003';
  sqlExecuteModal.isVisible = true
  if (validateSqlForm()) {
    Modal.info({
      content: '执行 SQL 脚本：' + sqlEditForm.sql_script.substring(0, 50) + '...',
      onOk: async () => {
        try {
          const params = {
            apicode: 'Sys_ExecSQL',
            DBName: sqlEditForm.db_name,
            SQLScript: f.ecode(sqlEditForm.sql_script)
          }
          const data = await dm.value.exec('/api/comm/exec/', params)
          if (data) {
            sqlEditForm.SqlChanged = false
            message.success('执行成功！')
            // 可根据返回结果做后续处理
          } else {
            message.error('执行失败！')
          }
        } catch (error) {
          message.error('执行时发生错误：' + error.message)
        }
      }
    })
  }
}
// 重命名（项目编码）
const sql_rename = async () => {
  const result = await f.input('重命名', '请输入项目编码', sqlEditForm.item_code)
  if (result !== null) {
    sqlEditForm.item_code = result
    sqlModal.title = '重命名脚本 ' + result
  }
}
// 渲染数据库选择下拉
const renderSqlDbDropdown = () => {
  return h(
    Select,
    {
      placeholder: '选择执行数据库',
      style: { width: 150, minWidth: '150px', margin: '0 8px' },
      value: sqlEditForm.db_name,
      onChange: (value: string) => {
        sqlEditForm.db_name = value
      }
    },
    {
      default: () => dbDropdownOptions.map((option) => h(Option, { value: option.value }, option.label))
    }
  )
}

// 表格列配置
const columns = [
  { title: '标识', dataIndex: 'ItemCode', minWidth: 100, width: 80, align: 'left' },
  { title: '操作说明', dataIndex: 'ItemName', width: 120, align: 'left' },
  { title: '数据库', dataIndex: 'DBName', width: 80, align: 'center' },
  {
    title: '修改时间',
    dataIndex: 'EditTime',
    width: 120,
    align: 'center',
    customRender: (value) => f.formatDateTime(value, 'yyyy-MM-dd')
  },
  {
    title: '',
    width: 10,
    render: () => null
  }
]


// 底部编辑器配置
const cmOptions = {
  mode: 'text/x-sql',
  theme: 'idea',
  lineNumbers: true,
  lineWrapping: true,
  debug: false  ,
  tabSize: 4,
  readOnly: false,
  hintOptions: {
    completeSingle: false,
    tables: {
      BPSuv: ['DocEntry', 'Subject', 'DocStatus', 'Remarks'],
      BPSuvA: ['DocEntry', 'LineNum', 'Question', 'QstType'],
      BPSuvB: ['DocEntry', 'LineNum', 'UserID', 'UserName']
    }
  }
}

// ======================== 新增SQL编辑弹窗功能变量 ========================
// SQL编辑表单数据
const sqlEditForm = reactive({
  item_guid: '',
  item_code: '',
  item_name: 'item-name',
  sql_script: '-- 请输入 SQL 脚本',
  db_name: null as string | 'SYS',
  SqlChanged: false
})

// 新增：内容变化时触发



// SQL编辑弹窗工具栏
// 再定义工具栏配置（此时已能访问 renderSqlDbDropdown）
// 替换原有 sqlEditTools 定义
const sqlEditTools = computed<ToolbarItemProps[]>(() => [
  {
    type: 'custom',
    render: renderSqlDbDropdown,
    tooltip: '选择执行数据库'
  },
  {
    label: '重命名',
    tooltip: '重命名项目编码',
    onClick: sql_rename
  },
  {
    label: '参数',
    tooltip: '配置 SQL 参数',
    onClick: () => Modal.info({ content: '参数配置功能待实现' })
  },
  {
    label: '执行',
    tooltip: '执行 SQL 脚本',
    onClick: sql_run
  },
  {
    label: '保存',
    tooltip: '保存当前脚本（不关闭）',
    onClick: () => saveSql(false)
  },
  {
    label: '保存关闭',
    tooltip: '保存并关闭弹窗',
    onClick: () => saveSql(true)
  },
  {
    // 响应式更新 label/tooltip
    label: isSqlEditorFullScreen.value ? '退出全屏' : '全屏',
    tooltip: isSqlEditorFullScreen.value ? '退出全屏' : '全屏',
    onClick: sql_full_screen
  },
  {
    label: '关闭',
    tooltip: '关闭弹窗',
    onClick: handleSqlModalClose
  }
])
// SQL编辑器配置
const sqlCmOptions = {
  mode: 'text/x-sql',
  theme: 'idea',
  lineNumbers: true,
  lineWrapping: true,
  tabSize: 4,
  readOnly: false,
  hintOptions: {
    completeSingle: false,
    tables: {
      BPSuv: ['DocEntry', 'Subject', 'DocStatus', 'Remarks'],
      BPSuvA: ['DocEntry', 'LineNum', 'Question', 'QstType'],
      BPSuvB: ['DocEntry', 'LineNum', 'UserID', 'UserName']
    }
  },
  extraKeys: {
    // 可选：禁用默认右键菜单（也可通过CSS禁用）
    ContextMenu: (cm: Editor) => {
      cm.display.wrapper.style.cursor = 'default'
    }
  }
}

// 数据库下拉选项
const dbDropdownOptions = [
  { label: 'SYS', value: 'SYS' },
  { label: 'DBCenter', value: 'DBCenter' }
]

// ======================== 原有页面方法 ========================
// 关闭执行弹窗
const handleClose = (success: boolean) => {
  sqlModal.isVisible = false
  if (success) {
    // console.log('执行成功，可做后续处理')
  }
}

// 底部编辑器初始化
const onReady = (cm) => {
  // 关键修改1：拆分词汇列表（基础关键字 + 独立日期函数）
  const keywordList = [
  'select', 'from', 'where', 'group by', 'having', 'order by', 'distinct', 'top', 'offset', 'fetch', 'into', 'as', 'join', 'inner join', 'left join',
  'right join', 'full join', 'cross join', 'outer join', 'on', 'using', 'union', 'union all', 'intersect', 'except',  'between', 'like', 'exists',
  'any', 'all', 'some', 'insert', 'update', 'delete', 'merge', 'insert into', 'update set', 'delete from', 'values', 'set', 'output', 'default',
  'create', 'alter', 'drop', 'rename', 'truncate', 'declare', 'table', 'view', 'procedure', 'function', 'trigger', 'schema', 'database',
  'column', 'constraint', 'primary key', 'foreign key', 'unique', 'check', 'identity', 'partition', 'filegroup', 'login', 'user', 'role', 'if', 'else',
  'while', 'begin', 'end', 'case', 'when', 'then', 'break', 'continue', 'goto', 'return', 'try', 'catch', 'throw', 'raiserror',
  'waitfor', 'begin transaction', 'commit', 'rollback', 'save transaction', 'grant', 'revoke', 'deny', 'execute', 'exec', 'as', 'with', 'ownership',
  'cursor', 'open', 'fetch', 'close', 'deallocate', 'variable', 'global', 'local', '@@', 'and', 'or', 'not', 'asc', 'desc',
  'null', 'is null', 'is not null', 'not in', 'not like', 'escape', 'collate', 'over', 'partition by', 'row_number', 'rank', 'dense_rank', 'ntile',
  'for', 'xml', 'json', 'option', 'recompile', 'lock', 'nolock', 'read uncommitted', 'read committed', 'varchar', 'nvarchar', 'char', 'nchar',
  'text', 'ntext', 'int', 'bigint', 'smallint', 'tinyint', 'bit', 'decimal', 'numeric', 'float', 'real', 'money', 'smallmoney',
  'datetime', 'datetime2', 'smalldatetime', 'date', 'time', 'datetimeoffset'
];

const sqlFuncList = [
  'getdate', 'getutcdate', 'sysdatetime', 'sysdatetimeoffset', 'sysutcdatetime', 'current_timestamp', 'datepart', 'datename', 'year', 'month',
  'day', 'hour', 'minute', 'second', 'millisecond', 'microsecond', 'nanosecond', 'datefromparts', 'datetime2fromparts', 'datetimefromparts',
  'datetimeoffsetfromparts', 'smalldatetimefromparts', 'timefromparts', 'dateadd', 'datediff', 'datediff_big', 'eomonth', 'isdate', 'format',
  'switcheoffset', 'todatetimeoffset', 'datediff_legacy', 'dateadd_legacy', 'charindex', 'concat', 'concat_ws', 'datalength', 'difference',
  'left', 'len', 'lower', 'ltrim', 'patindex', 'quotename', 'replace', 'reverse', 'right', 'rtrim', 'soundex',  'str', 'stuff',
  'substring', 'trim', 'unicode', 'upper', 'ascii', 'string_escape', 'string_split', 'translate', 'abs', 'acos', 'asin', 'atan', 'atan2',
  'ceiling', 'cos', 'cot', 'degrees', 'exp', 'floor', 'log', 'log10', 'mod', 'pi', 'power', 'radians', 'rand', 'round',
  'sign', 'sin', 'sqrt', 'square', 'tan', 'big_count', 'count_big', 'avg', 'sum', 'min', 'max', 'stdev', 'stdevp', 'var',
  'varp', 'cast', 'convert', 'parse', 'try_cast', 'try_convert', 'try_parse', 'isnull', 'coalesce', 'nullif', 'iif', 'app_name',
  'collationproperty', 'col_length', 'col_name', 'current_user', 'databasepropertyex', 'db_name', 'host_name', 'is_member', 'is_rolemember',
  'object_id', 'object_name', '@@error', '@@identity', '@@rowcount', '@@version', 'suser_sname', 'user_name', 'session_user', 'system_user',
  'binary_checksum', 'checksum', 'checksum_agg', 'count', 'grouping', 'grouping_id', 'isjson', 'json_value', 'json_query', 'json_modify',
  'openjson', 'hashbytes', 'encryptbykey', 'decryptbykey', 'encryptbypassphrase', 'decryptbypassphrase', 'signbycert', 'verifybycert',
  'pwdencrypt', 'pwdcompare', 'newid', 'newsequentialid', 'row_number', 'rank', 'dense_rank', 'ntile', 'percent_rank', 'cume_dist',
  'choose', 'parsename', 'replicate', 'xp_logininfo'
];

// 注册自定义高亮模式
if (window.CodeMirror) {
  delete window.CodeMirror.modes['custom-mssql']

  // 1. 预处理关键字：拆分为单字和多字，构建映射表（CodeMirror 官方推荐）
  const keywordMap: Record<string, boolean> = {};
  const multiWordKeywords: Record<string, boolean> = {};
  
  // 处理多字关键字（如 'group by'）
  keywordList.forEach(keyword => {
    if (keyword.includes(' ')) {
      multiWordKeywords[keyword.toLowerCase()] = true;
      // 拆分多字关键字为单字，避免单字误匹配
      keyword.split(' ').forEach(word => {
        if (word) keywordMap[word.toLowerCase()] = true;
      });
    } else {
      keywordMap[keyword.toLowerCase()] = true;
    }
  });

  // 处理函数名映射
  const funcMap: Record<string, boolean> = {};
  sqlFuncList.forEach(func => {
    funcMap[func.toLowerCase()] = true;
  });

  // 2. 工具函数：判断是否是单词边界（CodeMirror 标准）
  const isWordChar = (ch: string | null) => {
    return ch && (/\w/.test(ch) || ch === '@' || ch === '#');
  };

  // 3. 核心：修复推流问题的 token 函数（仅新增推流保障，保留原有高亮逻辑）
  window.CodeMirror.defineMode('custom-mssql', () => ({
    startState: () => ({
      inComment: false,
      inString: '',
      lastWord: '', // 记录上一个单词，处理多字关键字
      inMultiWordKeyword: false
    }),
    token: (stream, state) => {
      // ========== 修复点1：行尾强制推进流 ==========
      if (stream.eol()) {
        state.lastWord = '';
        state.inMultiWordKeyword = false;
        stream.next(); // 强制消费行尾字符，避免流停滞
        return null;
      }

      // 1. 多行注释处理（强制推进流）
      if (state.inComment) {
        const found = stream.skipTo('*/');
        if (found) {
          stream.eat('*');
          stream.eat('/'); // 消费 */ 两个字符
          state.inComment = false;
        } else {
          stream.skipToEnd(); // 消费剩余所有字符
        }
        return 'comment';
      }

      // 2. 字符串处理（逐字符消费，避免流停滞）
      if (state.inString) {
        // 修复点2：字符串必须逐字符消费，且处理流末尾
        if (stream.eol()) {
          stream.next();
          return 'string';
        }
        const ch = stream.next(); // 强制消费一个字符
        if (ch === state.inString && stream.peek() !== state.inString) {
          state.inString = '';
        }
        // 处理转义引号（'' 或 ""）
        if (ch === state.inString && stream.peek() === state.inString) {
          stream.next(); // 消费第二个引号
        }
        return 'string';
      }

      // 3. 跳过空白符（强制消费所有空白）
      if (stream.eatSpace()) {
        // 如果处于多字关键字中，拼接空格
        if (state.inMultiWordKeyword) {
          state.lastWord += ' ';
        }
        return null;
      }

      // 4. 单行注释（强制消费整行）
      if (stream.match(/^--/, false)) {
        stream.skipToEnd(); // 消费剩余所有字符
        return 'comment';
      }

      // 5. 多行注释开始（强制消费 /* 两个字符）
      if (stream.match(/^\/\*/, false)) {
        stream.next(); // 消费 /
        stream.next(); // 消费 *
        state.inComment = true;
        return 'comment';
      }

      // 6. 字符串开始（强制消费引号）
      const ch = stream.peek();
      if (ch && (ch === "'" || ch === '"')) {
        state.inString = stream.next(); // 消费引号字符
        return 'string';
      }

      // 7. 数字匹配（强制消费数字字符）
      if (stream.match(/^\d+(\.\d+)?(e[+-]?\d+)?/i, false)) {
        stream.match(/^\d+(\.\d+)?(e[+-]?\d+)?/i); // 消费数字字符
        return 'number';
      }

      // 8. 运算符匹配（强制消费运算符）
      if (stream.match(/^[()=<>+*/%,.;:\-[\]{}@'"\\]/, false)) {
        // 遇到运算符，重置多字关键字状态
        state.lastWord = '';
        state.inMultiWordKeyword = false;
        stream.next(); // 消费运算符字符
        return 'operator';
      }

      // 9. 核心：单词匹配（修复空单词导致的流停滞）
      let currentWord = '';
      // 读取完整单词（直到非单词字符，强制消费）
      while (isWordChar(stream.peek())) {
        currentWord += stream.next(); // 逐字符消费，确保流推进
      }

      // ========== 修复点3：空单词兜底（强制消费一个字符） ==========
      if (currentWord === '') {
        stream.next(); // 无单词时，强制消费一个字符，避免流卡死
        return 'variable';
      }

      const lowerWord = currentWord.toLowerCase();

      // 9.1 处理多字关键字（如 'group by'）
      let fullKeyword = state.lastWord + currentWord;
      if (multiWordKeywords[fullKeyword]) {
        state.inMultiWordKeyword = false;
        state.lastWord = '';
        return 'keyword';
      }

      // 9.2 处理函数名（必须后接括号）
      if (funcMap[lowerWord] && stream.peek() === '(') {
        return 'date-function';
      }

      // 9.3 处理单字关键字（仅独立单词）
      if (keywordMap[lowerWord] && !state.inMultiWordKeyword) {
        // 检查前后是否是单词边界（彻底排除子串）
        const prevChar = stream.pos > currentWord.length ? stream.string.charAt(stream.pos - currentWord.length - 1) : '';
        const nextChar = stream.peek();
        if (!isWordChar(prevChar) && !isWordChar(nextChar)) {
          // 标记可能的多字关键字开始
          state.inMultiWordKeyword = true;
          state.lastWord = lowerWord + ' ';
          return 'keyword';
        }
      }

      // 重置多字关键字状态
      state.inMultiWordKeyword = false;
      state.lastWord = '';

      // 10. 兜底：确保流已推进（当前Word已消费字符）
      return 'variable';
    }
  }))

  // 应用模式并强制刷新（增加延迟，避免渲染时序问题）
  cm.setOption('mode', 'custom-mssql')
  cm.refresh()
  setTimeout(() => cm.refresh(), 0)
}
}

// 表格行自定义事件
const customRow = (record: TableRowData) => {
  let clickTimer: number | null = null
  return {
    // style: { cursor: 'pointer' },
    'data-record': JSON.stringify(record),
    onClick: (event: MouseEvent) => {
      // 单击事件：延迟300ms执行，若300ms内触发双击则取消
      if (clickTimer) clearTimeout(clickTimer)
      clickTimer = window.setTimeout(() => {
        // console.log('单击', record);
      }, 300)
      currentRow.value = record
      code.value = record.SQLScript || ''
    },
    ondblclick: () => {
      // 双击事件：清除单击定时器，执行双击逻辑
      if (clickTimer) clearTimeout(clickTimer)
      currentRow.value = record
      code.value = record.SQLScript || ''
      if (currentRow.value) {
        openSqlEditModal(currentRow.value)
      } else {
        f.warning('请先选择一行数据')
      }
      // f.showmessage("双击");
      // console.log('双击', record);
    },
    onContextmenu: (event: MouseEvent) => {
      event.preventDefault()
      currentRow.value = record
      isContextMenuShow.value = true
    }
  }
}

// 搜索数据
const search = async () => {
  try {
    allTableData.value = []
    var selDate = selectedDate.value
    if (!isFilterEnabled.value) {
      selDate = ''
    }
    var params = {
      apicode: 'Sys_SQLFind_API',
      Key: `%${inputValue.value}%`,
      Where: selDate
    }
    const data = await dm.value.data('/api/comm/data/', params)
    if (data && data.data && Array.isArray(data.data.list)) {
      allTableData.value = data.data.list
      current.value = 1
    } else {
      allTableData.value = []
    }
  } catch (error) {
    console.error('获取数据失败:', error)
    allTableData.value = []
  }
}
// 核心打包方法（完全保留原始空行/换行/缩进）
const packToClipboard = async (currentRow) => {
  const label = '当前项目'
  try {
    if (!currentRow) {
      f.error(`请先选择表格行！`)
      return
    }

    // 1. 安全提取字段（空值兜底，不做任何格式修改）
    const SQLScript = currentRow.SQLScript || ''
    const ItemName = currentRow.ItemName || ''
    const ItemCode = currentRow.ItemCode || ''
    const EditTime = currentRow.EditTime || ''
    const EditUser = currentRow.EditUser || ''
    const DBName = currentRow.DBName || ''
    const ItemType = currentRow.ItemType || ''
    const NeedUpdate = currentRow.NeedUpdate || ''
    const Stop = currentRow.Stop || ''

    const escapeOnlyBackslash = (str) => {
      return str.replace(/\\/g, '\\\\') // 只转义反斜杠，其他字符（包括换行/空行）完全保留
    }

    // 3. 手动拼接JSON（不清理任何缩进/换行，保留原始格式）
    // 注意：拼接时SQLScript前保留\r\n，其余字段直接拼接，不修改空行
    const jsonText = `{"cmd":"CopySingSQLHead","SQLScript":"\r\n${escapeOnlyBackslash(SQLScript)}","ItemName":"${escapeOnlyBackslash(ItemName)}","ItemCode":"${escapeOnlyBackslash(ItemCode)}","EditTime":"${escapeOnlyBackslash(EditTime)}","EditUser":"${escapeOnlyBackslash(EditUser)}","DBName":"${escapeOnlyBackslash(DBName)}","ItemType":"${escapeOnlyBackslash(ItemType)}","NeedUpdate":"${escapeOnlyBackslash(NeedUpdate)}","Stop":"${escapeOnlyBackslash(Stop)}"}`

    // 4. 复制到剪贴板
    await copyToClipboard(jsonText, '打包脚本')

    // f.success(`复制${label}成功！`)
  } catch (err) {
    console.error(`复制失败:`, err)
    // f.error(`复制${label}失败！`)
  }
}


const handleContextMenuClick = async (key: string) => {
  if (!currentRow.value) {
    f.warning('未获取到当前行数据')
    return
  }

  switch (key) {
    case 'copy1':
      copyToClipboard(currentRow.value.ItemCode, '标识')
      break
    case 'copy2':
      copyToClipboard(currentRow.value.ItemName, '操作说明')
      break
    case 'copy3':
      copyToClipboard(currentRow.value.SQLScript || '', 'SQL脚本')
      break
    case 'run':
      sqlExecuteModal.isVisible = true
      sqlExecuteModal.itemCode = currentRow.value.ItemCode
      break
    case 'script_pack':
      // 打开SQL编辑弹窗并加载当前行数据
      packToClipboard(currentRow.value)
      break
    case 'runscript1':
    // 前置校验
      if (!currentRow.value) {
        f.warning('请先选择表格中的脚本行！');
        return;
      }
      // 直接调用已封装的生成方法
      generateExecScript(currentRow.value.SQLScript,currentRow.value.ItemCode);
      break  
    case 'runscript2':
    // 前置校验
      if (!currentRow.value) {
        f.warning('请先选择表格中的脚本行！');
        return;
      }
      // 直接调用已封装的生成方法
      generateAntdDsScript(currentRow.value.SQLScript,currentRow.value.ItemCode);
      break

    case 'runscript3':
      openSqlEditModal(currentRow.value)
      break
    case 'load_item':
      try {
        const loadParams = {
          itemCode: currentRow.value.ItemCode
        }
        const loadData = await dm.value.data('/api/comm/load_item/', loadParams)
        console.log('load_item', loadData)
        // 关键修改：按后端实际返回格式判断（status=0 表示成功）
        if (loadData?.status === 0) {
          f.success(`后台重载${currentRow.value.ItemCode}成功！`)
        } else {
          f.error(`${currentRow.value.ItemCode} 缓存同步返回异常：失败！`)
        }
      } catch (loadError) {
        f.error(`缓存同步失败 ${currentRow.value.ItemCode} ！`)
      }
      break
  }
}

// 复制到剪贴板
const copyToClipboard = async (text: string, label: string, successText?: string) => {
  try {
    await navigator.clipboard.writeText(text)
    // 优先使用自定义提示，无则使用默认
    f.success(successText || `复制${label}成功！`)
  } catch (err) {
    console.error(`复制${label}失败:", err`)
    f.error(`复制${label}失败！`)
  }
}

// 顶部工具栏渲染组件
const selectedDate = ref<string>(f.getDate())
const renderDatePicker = () => {
  return h(DatePicker, {
    style: { width: '150px' },
    placeholder: '选择日期',
    value: selectedDate.value ? dayjs(selectedDate.value) : null,
    onChange: (_date: unknown, dateString: string) => {
      selectedDate.value = dateString
      search() // 执行核心逻辑
    }
  })
}

const inputValue = ref('')
const renderInput = () => {
  return h(Input, {
    style: { width: '300px' },
    placeholder: '请输入关键词',
    value: inputValue.value,
    onChange: (e: Event) => {
      const val = (e.target as HTMLInputElement).value
      inputValue.value = val
    },
    // 监听键盘按下事件，判断回车键
    onKeydown: (e: KeyboardEvent) => {
      // antd-vue 兼容标准键盘事件，直接判断 Enter 键
      if (e.key === 'Enter' || e.keyCode === 13) {
        e.preventDefault() // 阻止默认行为（避免表单提交/页面刷新）
        search() // 执行核心逻辑
      }
    },
    // 可选：添加清除按钮（antd-vue Input 自带属性）
    allowClear: true,
    // 可选：输入框聚焦时的回调
    // onFocus: () => console.log('输入框聚焦')
  })
}

const isFilterEnabled = ref(true)
const renderCheckbox = () => {
  return h(Checkbox, {
    label: '启用筛选',
    checked: isFilterEnabled.value,
    'onUpdate:checked': (checked: boolean) => {
      isFilterEnabled.value = checked
    }
  })
}

// 顶部工具栏配置
const leftTools = reactive<ToolbarItemProps[]>([
  {
    label: '新增',
    tooltip: '创建新脚本',
    icon: icon({ name: 'PlusOutlined' }),
    onClick: () => openSqlEditModal() // 点击新增打开编辑弹窗
  },
  {
    label: '修改',
    tooltip: '修改当前脚本',
    icon: icon({ name: 'EditOutlined' }),
    onClick: () => {
      if (currentRow.value) {
        openSqlEditModal(currentRow.value)
      } else {
        f.warning('请先选择一行数据')
      }
    }
  },
  {
    label: '删除',
    tooltip: '删除当前脚本',
    icon: icon({ name: 'DeleteOutlined' }),
    onClick: () => {
      if (currentRow.value) {
        Modal.confirm({
          title: '确认删除',
          content: `是否删除脚本【${currentRow.value.ItemName}】`,
          onOk: async () => {
            try {
              const params = {
                apicode: 'Sys_DeleteSQL',
                Guid: currentRow.value.Guid
              }
              const data = await dm.value.exec('/api/comm/exec/', params)
              if (data) {
                f.success('删除成功')
                search() // 重新加载数据
              } else {
                f.error('删除失败')
              }
            } catch (error) {
              f.error('删除时发生错误：' + error.message)
            }
          }
        })
      } else {
        f.warning('请先选择一行数据')
      }
    }
  },
  { type: 'separator' },
  {
    type: 'custom',
    render: renderCheckbox
  },
  {
    type: 'custom',
    render: renderDatePicker
  },
  {
    type: 'custom',
    render: renderInput
  },
  {
    label: '查找',
    tooltip: '查找关键字',
    onClick: () => search()
  }
])

// 顶部工具栏点击事件
const handleToolbarMenuClick = (item: ToolbarItemProps, menuKey: string) => {
  console.log('工具栏菜单点击：', menuKey)
  if (menuKey === 'pdf') console.log('选择PDF')
  if (menuKey === 'word') console.log('选择Word')
}

// ======================== 新增SQL编辑弹窗方法 ========================
// 打开SQL编辑弹窗（支持新增/编辑）
const openSqlEditModal = async (row?: TableRowData) => {
  // 重置表单
  sqlEditForm.item_guid = ''
  sqlEditForm.item_code = ''
  sqlEditForm.item_name = ''
  sqlEditForm.sql_script = ''
  sqlEditForm.db_name =  'SYS' 
  sqlEditForm.SqlChanged = false
  

  // 如果是新增（无row参数），获取新脚本序列号
  if (!row) {
    try {
      // 调用获取新脚本ID的接口（和之前addScript中的接口一致）
      const params = {
        apicode: 'S_Get_New_SQLScriptSN'
      }
      const newScriptId = await dm.value.getValue('/api/comm/data/', params)
      if (newScriptId) {
        sqlEditForm.item_code = newScriptId // 自动赋值新序列号
        sqlModal.title = '新增脚本 ' + newScriptId
        console.log(newScriptId)
      } else {
        f.warning('获取新脚本编号失败，需手动输入')
      }
    } catch (error) {
      console.error('获取新脚本序列号失败：', error)
      f.error('获取编号失败，请手动输入')
    }
  }
  // 如果是编辑，加载行数据
  else {
    sqlEditForm.item_guid = row.Guid || ''
    sqlEditForm.item_code = row.ItemCode || ''
    sqlEditForm.item_name = row.ItemName || ''
    sqlEditForm.sql_script = row.SQLScript || ''
    sqlEditForm.db_name = row.DBName || null
  }

  // 打开弹窗
  sqlModal.isVisible = true
  nextTick(() => {
    sqlCmInstance.value?.refresh()
  })
}
// 处理编辑器右键事件

const isSqlCmReady = ref(false)
// SQL编辑器初始化
const handleSqlCmReady = (cm: Editor) => {
  const editorDom = cm.getWrapperElement()
  // 监听编辑器右键事件（核心）
  editorDom.addEventListener('contextmenu', handleEditorContextMenu)
  sqlCmInstance.value = cm

  isSqlCmReady.value = true 

  // 内部监听键盘事件（替代模板中的 @keydown）
  cm.on('keydown', (instance: Editor, event: any) => {
    // 把原生 KeyboardEvent 传给 handleInputKeydown
    
    const nativeEvent = event.nativeEvent || event;
    handleInputKeydown(nativeEvent);
  });  

  // 替换 handleSqlCmReady 中的 change 事件监听
  cm.on('change', (instance: Editor, changeObj: any) => {
    // 仅保留「用户主动修改」的场景，过滤所有代码触发的假修改
    const validOrigins = ['+input', '-delete', 'paste', 'cut', 'drop', 'undo', 'redo'];
    const isUserChange = validOrigins.includes(changeObj.origin) || !changeObj.origin;
    
    // 额外校验：内容真的发生了变化（避免空触发）
    const oldValue = changeObj.oldText?.join('\n') || '';
    const newValue = instance.getValue();
    const isContentChanged = oldValue !== newValue;

    // 只有「用户操作 + 内容真变化」时，才标记 SqlChanged
    if (isUserChange && isContentChanged) {
      sqlEditForm.SqlChanged = true;
    }
  });

  // 监听编辑器右键事件（核心）
  // 手动定义SQL语法高亮（和底部编辑器保持一致）
  // 关键修改1：拆分词汇列表（基础关键字 + 独立日期函数）
  const keywordList = [
  'select', 'from', 'where', 'group by', 'having', 'order by', 'distinct', 'top', 'offset', 'fetch', 'into', 'as', 'join', 'inner join', 'left join',
  'right join', 'full join', 'cross join', 'outer join', 'on', 'using', 'union', 'union all', 'intersect', 'except',  'between', 'like', 'exists',
  'any', 'all', 'some', 'insert', 'update', 'delete', 'merge', 'insert into', 'update set', 'delete from', 'values', 'set', 'output', 'default',
  'create', 'alter', 'drop', 'rename', 'truncate', 'declare', 'table', 'view', 'procedure', 'function', 'trigger', 'schema', 'database',
  'column', 'constraint', 'primary key', 'foreign key', 'unique', 'check', 'identity', 'partition', 'filegroup', 'login', 'user', 'role', 'if', 'else',
  'while', 'begin', 'end', 'case', 'when', 'then', 'break', 'continue', 'goto', 'return', 'try', 'catch', 'throw', 'raiserror',
  'waitfor', 'begin transaction', 'commit', 'rollback', 'save transaction', 'grant', 'revoke', 'deny', 'execute', 'exec', 'as', 'with', 'ownership',
  'cursor', 'open', 'fetch', 'close', 'deallocate', 'variable', 'global', 'local', '@@', 'and', 'or', 'not', 'asc', 'desc',
  'null', 'is null', 'is not null', 'not in', 'not like', 'escape', 'collate', 'over', 'partition by', 'row_number', 'rank', 'dense_rank', 'ntile',
  'for', 'xml', 'json', 'option', 'recompile', 'lock', 'nolock', 'read uncommitted', 'read committed', 'varchar', 'nvarchar', 'char', 'nchar',
  'text', 'ntext', 'int', 'bigint', 'smallint', 'tinyint', 'bit', 'decimal', 'numeric', 'float', 'real', 'money', 'smallmoney',
  'datetime', 'datetime2', 'smalldatetime', 'date', 'time', 'datetimeoffset'
];

const sqlFuncList = [
  'getdate', 'getutcdate', 'sysdatetime', 'sysdatetimeoffset', 'sysutcdatetime', 'current_timestamp', 'datepart', 'datename', 'year', 'month',
  'day', 'hour', 'minute', 'second', 'millisecond', 'microsecond', 'nanosecond', 'datefromparts', 'datetime2fromparts', 'datetimefromparts',
  'datetimeoffsetfromparts', 'smalldatetimefromparts', 'timefromparts', 'dateadd', 'datediff', 'datediff_big', 'eomonth', 'isdate', 'format',
  'switcheoffset', 'todatetimeoffset', 'datediff_legacy', 'dateadd_legacy', 'charindex', 'concat', 'concat_ws', 'datalength', 'difference',
  'left', 'len', 'lower', 'ltrim', 'patindex', 'quotename', 'replace', 'reverse', 'right', 'rtrim', 'soundex',  'str', 'stuff',
  'substring', 'trim', 'unicode', 'upper', 'ascii', 'string_escape', 'string_split', 'translate', 'abs', 'acos', 'asin', 'atan', 'atan2',
  'ceiling', 'cos', 'cot', 'degrees', 'exp', 'floor', 'log', 'log10', 'mod', 'pi', 'power', 'radians', 'rand', 'round',
  'sign', 'sin', 'sqrt', 'square', 'tan', 'big_count', 'count_big', 'avg', 'sum', 'min', 'max', 'stdev', 'stdevp', 'var',
  'varp', 'cast', 'convert', 'parse', 'try_cast', 'try_convert', 'try_parse', 'isnull', 'coalesce', 'nullif', 'iif', 'app_name',
  'collationproperty', 'col_length', 'col_name', 'current_user', 'databasepropertyex', 'db_name', 'host_name', 'is_member', 'is_rolemember',
  'object_id', 'object_name', '@@error', '@@identity', '@@rowcount', '@@version', 'suser_sname', 'user_name', 'session_user', 'system_user',
  'binary_checksum', 'checksum', 'checksum_agg', 'count', 'grouping', 'grouping_id', 'isjson', 'json_value', 'json_query', 'json_modify',
  'openjson', 'hashbytes', 'encryptbykey', 'decryptbykey', 'encryptbypassphrase', 'decryptbypassphrase', 'signbycert', 'verifybycert',
  'pwdencrypt', 'pwdcompare', 'newid', 'newsequentialid', 'row_number', 'rank', 'dense_rank', 'ntile', 'percent_rank', 'cume_dist',
  'choose', 'parsename', 'replicate', 'xp_logininfo'
];

// 注册自定义高亮模式
if (window.CodeMirror) {
  delete window.CodeMirror.modes['custom-mssql']

  // 1. 预处理关键字：拆分为单字和多字，构建映射表（CodeMirror 官方推荐）
  const keywordMap: Record<string, boolean> = {};
  const multiWordKeywords: Record<string, boolean> = {};
  
  // 处理多字关键字（如 'group by'）
  keywordList.forEach(keyword => {
    if (keyword.includes(' ')) {
      multiWordKeywords[keyword.toLowerCase()] = true;
      // 拆分多字关键字为单字，避免单字误匹配
      keyword.split(' ').forEach(word => {
        if (word) keywordMap[word.toLowerCase()] = true;
      });
    } else {
      keywordMap[keyword.toLowerCase()] = true;
    }
  });

  // 处理函数名映射
  const funcMap: Record<string, boolean> = {};
  sqlFuncList.forEach(func => {
    funcMap[func.toLowerCase()] = true;
  });

  // 2. 工具函数：判断是否是单词边界（CodeMirror 标准）
  const isWordChar = (ch: string | null) => {
    return ch && (/\w/.test(ch) || ch === '@' || ch === '#');
  };

  // 3. 核心：修复推流问题的 token 函数（仅新增推流保障，保留原有高亮逻辑）
  window.CodeMirror.defineMode('custom-mssql', () => ({
    startState: () => ({
      inComment: false,
      inString: '',
      lastWord: '', // 记录上一个单词，处理多字关键字
      inMultiWordKeyword: false
    }),
    token: (stream, state) => {
      // ========== 修复点1：行尾强制推进流 ==========
      if (stream.eol()) {
        state.lastWord = '';
        state.inMultiWordKeyword = false;
        stream.next(); // 强制消费行尾字符，避免流停滞
        return null;
      }

      // 1. 多行注释处理（强制推进流）
      if (state.inComment) {
        const found = stream.skipTo('*/');
        if (found) {
          stream.eat('*');
          stream.eat('/'); // 消费 */ 两个字符
          state.inComment = false;
        } else {
          stream.skipToEnd(); // 消费剩余所有字符
        }
        return 'comment';
      }

      // 2. 字符串处理（逐字符消费，避免流停滞）
      if (state.inString) {
        // 修复点2：字符串必须逐字符消费，且处理流末尾
        if (stream.eol()) {
          stream.next();
          return 'string';
        }
        const ch = stream.next(); // 强制消费一个字符
        if (ch === state.inString && stream.peek() !== state.inString) {
          state.inString = '';
        }
        // 处理转义引号（'' 或 ""）
        if (ch === state.inString && stream.peek() === state.inString) {
          stream.next(); // 消费第二个引号
        }
        return 'string';
      }

      // 3. 跳过空白符（强制消费所有空白）
      if (stream.eatSpace()) {
        // 如果处于多字关键字中，拼接空格
        if (state.inMultiWordKeyword) {
          state.lastWord += ' ';
        }
        return null;
      }

      // 4. 单行注释（强制消费整行）
      if (stream.match(/^--/, false)) {
        stream.skipToEnd(); // 消费剩余所有字符
        return 'comment';
      }

      // 5. 多行注释开始（强制消费 /* 两个字符）
      if (stream.match(/^\/\*/, false)) {
        stream.next(); // 消费 /
        stream.next(); // 消费 *
        state.inComment = true;
        return 'comment';
      }

      // 6. 字符串开始（强制消费引号）
      const ch = stream.peek();
      if (ch && (ch === "'" || ch === '"')) {
        state.inString = stream.next(); // 消费引号字符
        return 'string';
      }

      // 7. 数字匹配（强制消费数字字符）
      if (stream.match(/^\d+(\.\d+)?(e[+-]?\d+)?/i, false)) {
        stream.match(/^\d+(\.\d+)?(e[+-]?\d+)?/i); // 消费数字字符
        return 'number';
      }

      // 8. 运算符匹配（强制消费运算符）
      if (stream.match(/^[()=<>+*/%,.;:\-[\]{}@'"\\]/, false)) {
        // 遇到运算符，重置多字关键字状态
        state.lastWord = '';
        state.inMultiWordKeyword = false;
        stream.next(); // 消费运算符字符
        return 'operator';
      }

      // 9. 核心：单词匹配（修复空单词导致的流停滞）
      let currentWord = '';
      // 读取完整单词（直到非单词字符，强制消费）
      while (isWordChar(stream.peek())) {
        currentWord += stream.next(); // 逐字符消费，确保流推进
      }

      // ========== 修复点3：空单词兜底（强制消费一个字符） ==========
      if (currentWord === '') {
        stream.next(); // 无单词时，强制消费一个字符，避免流卡死
        return 'variable';
      }

      const lowerWord = currentWord.toLowerCase();

      // 9.1 处理多字关键字（如 'group by'）
      let fullKeyword = state.lastWord + currentWord;
      if (multiWordKeywords[fullKeyword]) {
        state.inMultiWordKeyword = false;
        state.lastWord = '';
        return 'keyword';
      }

      // 9.2 处理函数名（必须后接括号）
      if (funcMap[lowerWord] && stream.peek() === '(') {
        return 'date-function';
      }

      // 9.3 处理单字关键字（仅独立单词）
      if (keywordMap[lowerWord] && !state.inMultiWordKeyword) {
        // 检查前后是否是单词边界（彻底排除子串）
        const prevChar = stream.pos > currentWord.length ? stream.string.charAt(stream.pos - currentWord.length - 1) : '';
        const nextChar = stream.peek();
        if (!isWordChar(prevChar) && !isWordChar(nextChar)) {
          // 标记可能的多字关键字开始
          state.inMultiWordKeyword = true;
          state.lastWord = lowerWord + ' ';
          return 'keyword';
        }
      }

      // 重置多字关键字状态
      state.inMultiWordKeyword = false;
      state.lastWord = '';

      // 10. 兜底：确保流已推进（当前Word已消费字符）
      return 'variable';
    }
  }))

  // 应用模式并强制刷新（增加延迟，避免渲染时序问题）
  cm.setOption('mode', 'custom-mssql')
  cm.refresh()
  setTimeout(() => cm.refresh(), 0)
}
}

// 表单验证
const validateSqlForm = () => {
  if (!sqlEditForm.db_name) {
    message.warning('请选择执行数据库')
    return false
  }
  if (!sqlEditForm.sql_script.trim()) {
    Modal.error({ content: '脚本内容不能为空' })
    return false
  }
  if (!sqlEditForm.item_code.trim()) {
    Modal.error({ content: '脚本代码不能为空' })
    return false
  }
  if (!sqlEditForm.item_name.trim()) {
    Modal.error({ content: '脚本说明不能为空' })
    return false
  }
  return true
}

// 保存SQL脚本
const saveSql = async (closeAfterSave: boolean) => {
  if (validateSqlForm()) {
    const dateStr = f.getDateTime()
    const isAdd = !sqlEditForm.item_guid // 根据是否有guid判断新增/编辑
    const params = isAdd
      ? {
          apicode: 'Sys_AddSQL',
          ItemCode: sqlEditForm.item_code,
          Guid: f.guid(),
          ItemType: 'SQL',
          ItemName: sqlEditForm.item_name,
          NeedUpdate: 'Y',
          EditUser: sysInfo?.UserID || '',
          DBName: sqlEditForm.db_name,
          Stop: 0,
          EditTime: dateStr,
          SQLScript: sqlEditForm.sql_script
        }
      : {
          apicode: 'Sys_EditSQL',
          ItemCode: sqlEditForm.item_code,
          Guid: sqlEditForm.item_guid,
          ItemType: 'SQL',
          ItemName: sqlEditForm.item_name,
          NeedUpdate: 'Y',
          EditUser: sysInfo?.UserID || '',
          DBName: sqlEditForm.db_name,
          Stop: 0,
          EditTime: dateStr,
          SQLScript: sqlEditForm.sql_script
        }

    try {
      const data = await dm.value.exec('/api/comm/exec/', params, true)
      if (data) {
        sqlEditForm.SqlChanged = false
        message.success(isAdd ? '新增成功！' : '修改成功！')
        // 第二步：调用 load_item 接口同步缓存（修复响应判断逻辑）
        try {
          const loadParams = {
            itemCode: sqlEditForm.item_code,
            pass: 'reset'
          }
          const loadData = await dm.value.data('/api/comm/load_item/', loadParams)
          console.log('load_item', loadData)
          // 关键修改：按后端实际返回格式判断（status=0 表示成功）
          if (loadData?.status === 0) {
            console.log(`✅ 缓存同步成功：ItemCode=${sqlEditForm.item_code}`)
          } else {
            console.warn(`⚠️ 缓存同步返回异常：${JSON.stringify(loadData)}`)
            message.warning('脚本保存成功，但缓存同步返回异常！')
          }
        } catch (loadError) {
          console.error(`⚠️ 缓存同步失败：${(loadError as Error).message}`)
          message.warning('脚本保存成功，但缓存同步失败，请手动刷新缓存！')
        }

        if (closeAfterSave) {
          // 退出全屏（如果处于全屏状态）
          if (isSqlEditorFullScreen.value && screenfull.isEnabled) {
            screenfull.exit()
            isSqlEditorFullScreen.value = false
          }
          sqlModal.isVisible = false
          search() // 重新加载数据表格
        }
      } else {
        message.error(isAdd ? '新增失败！' : '修改失败！')
        
      }
    } catch (error) {
      message.error('保存时发生错误：' + error.message)
    }
  }
}

// SQL编辑弹窗工具栏点击事件
const handleSqlToolbarMenuClick = (item: ToolbarItemProps, menuKey: string) => {
  console.log('SQL编辑工具栏点击：', menuKey)
}

// ======================== 生命周期与全局样式 ========================
// 监听全屏变化（处理ESC退出）
// 保留一个 onMounted，合并所有逻辑
onMounted(() => {
  // 1. 加载数据
  search()

  // 2. 监听全局点击
  document.addEventListener('click', handleGlobalClick)

  // 3. 监听全屏事件
  if (screenfull.isEnabled) {
    screenfull.on('change', () => {
      const contentDom = document.querySelector('.sql-modal-content')
      // 仅当全屏元素是目标容器时更新状态
      const isTargetFullscreen = screenfull.isFullscreen && screenfull.element === contentDom
      isSqlEditorFullScreen.value = isTargetFullscreen

      // 同步编辑器高度
      const cmDom = document.getElementById('cm_sql_editor')
      if (cmDom) {
        cmDom.style.height = isTargetFullscreen 
          ? 'calc(100vh - 130px)' 
          : 'calc(70vh - 145px)'
        sqlCmInstance.value?.refresh()
      }

      // 样式控制
      if (contentDom) {
        contentDom.classList.toggle('screenfull-enabled', isTargetFullscreen)
        document.body.style.overflow = isTargetFullscreen ? 'hidden' : ''
      }
      document.body.style.background = isTargetFullscreen ? '#fff' : ''
    })
  }
  
  // 4. 样式修复
  nextTick(() => {
    const outerLayout = document.getElementById('layoutContent')
    if (outerLayout) {
      outerLayout.removeAttribute('style')
      outerLayout.style.margin = '0px'
      outerLayout.style.padding = '0px'
      outerLayout.style.height = '100%'
      outerLayout.style.cssText += 'margin: 0 !important; padding: 0 !important;'
    }

    const innerContent = document.querySelector('.layout-content[data-v-20207095]')
    if (innerContent) {
      innerContent.style.margin = '0 !important'
      innerContent.style.padding = '0 !important'
      innerContent.style.height = 'auto !important'
    }
  })
})

// 右键菜单配置
const contextMenuItems: ContextMenuItem[] = [
{ key: 'copy1', label: ' 复制标识' },

  { label: '---' },
  
  { key: 'copy2', label: ' 复制名称' },  
  { key: 'copy3', label: ' 复制脚本代码' },
  {
    key: 'run',
    label: ' 执行脚本'
    // ,icon: icon({  name:'DownloadOutlined',  size: 16,  color: '#ff00ff'})
  },
  { label: '---' },
  { key: 'script_pack', label: ' 脚本打包' },    
  {
    key: 'more',
    label: '生成代码',
    children: [
      { key: 'runscript1', label: '执行脚本' },
      { key: 'runscript2', label: '获取脚本数据集' },
      // { key: 'runscript3', label: '编辑脚本参数再执行' },
      // { key: 'runscript4', label: '对话框确认后执行' },
      { key: 'load_item', label: '后台重载当前脚本' }
    ]
  }
]

// 新增：生成Select脚本核心方法
// 新增：计算字符串实际显示宽度（适配中文字符）
const getStringDisplayWidth = (str: string): number => {
  // 中文字符占2个宽度，英文字符/数字占1个宽度
  let width = 0
  for (let i = 0; i < str.length; i++) {
    const charCode = str.charCodeAt(i)
    // 中文字符Unicode范围：0x4E00 - 0x9FFF
    if (charCode >= 0x4E00 && charCode <= 0x9FFF) {
      width += 2
    } else {
      width += 1
    }
  }
  return width
}

// 新增：生成Insert脚本核心方法
const generateInsertScript = async (tableName: string, cmInstance: Editor) => {
  // 1. 校验选中的表名是否为空
  if (!tableName || tableName.trim() === '') {
    f.warning('未选中表名，请先选中要生成插入的表名')
    return
  }

  try {
    // 2. 获取数据库表结构（复用Select的表结构查询逻辑）
    const dbName = sqlEditForm.db_name || 'SYS'
    const tableStructParams = {
      apicode: 'S_Table_Struce',
      TabName: tableName.trim(),
      DBName: dbName
    }

    const tableData = await dm.value.data('/api/comm/data/', tableStructParams)
    if (!tableData || !tableData.data || !Array.isArray(tableData.data.list)) {
      f.warning(`未查询到表【${tableName}】的结构信息`)
      return
    }
    const dt = tableData.data.list

    // 3. 计算字段名实际显示宽度（适配中文字符，复用Select的对齐逻辑）
    let maxDisplayWidth = 0
    dt.forEach((dr: any) => {
      const fieldName = dr['列名'] || ''
      maxDisplayWidth = Math.max(maxDisplayWidth, getStringDisplayWidth(fieldName))
    })
    const baseWidth = Math.max(maxDisplayWidth + 2, 30)

    // 4. 拼接字段列表和值列表（双列对齐）
    let fieldList = ''    // 字段名部分
    let valueList = ''    // 值占位符部分
    dt.forEach((dr: any, index: number) => {
      const fieldName = dr['列名'] || ''
      const cnName = dr['中文名'] || dr['列名'] || ''
      const fieldType = dr['数据类型'] || ''

      // 计算字段名填充空格（保持和Select一致的对齐风格）
      const currentWidth = getStringDisplayWidth(fieldName)
      const paddingCount = baseWidth - currentWidth
      const padding = ' '.repeat(paddingCount > 0 ? paddingCount : 1)
      
      // 字段行：带注释对齐
      const comment = cnName ? `-- ${cnName}` : ''
      const separator = index === dt.length - 1 ? '' : ',' // 最后一行不加逗号
      
      // 拼接字段名行
      fieldList += `,${fieldName}${padding}${comment}${separator}\r\n`
      
      // 拼接值占位符行（根据字段类型生成默认占位符）
      let defaultValue = getDefaultValueByType(fieldType)
      const valuePadding = ' '.repeat(currentWidth) // 值部分和字段名对齐
      valueList += `,${defaultValue}${valuePadding}${separator}\r\n`
    })

    // 移除开头的逗号，格式化字段/值列表
    if (fieldList.length > 0) {
      fieldList = fieldList.trimStart(',').replace(/,\r\n$/, '\r\n')
      valueList = valueList.trimStart(',').replace(/,\r\n$/, '\r\n')
    }

    // 5. 生成最终Insert SQL（兼容Oracle/SQLServer）
    const dbType = await getDbType(dbName)
    let insertSQL = ''
    
    if (dbType === 'OracleServer') {
      // Oracle Insert格式（支持序列/默认值）
      insertSQL = `\r\nINSERT INTO ${tableName} (\r\n${fieldList}) \r\nVALUES (\r\n${valueList})`
    } else {
      // SQLServer Insert格式（支持IDENTITY_INSERT）
      insertSQL = `\r\nSET IDENTITY_INSERT ${tableName} ON;\r\nINSERT INTO ${tableName} (\r\n${fieldList}) \r\nVALUES (\r\n${valueList});\r\nSET IDENTITY_INSERT ${tableName} OFF;`
    }

    // 6. 插入到编辑器并刷新
    cmInstance.replaceSelection(insertSQL)
    cmInstance.setSelection(cmInstance.getCursor(), cmInstance.getCursor())
    cmInstance.refresh()

    f.success(`成功生成【${tableName}】的Insert插入脚本（字段已对齐）`)
  } catch (error) {
    console.error('生成Insert脚本失败：', error)
    f.error(`生成Insert脚本失败：${(error as Error).message}`)
  }
}

// 新增：根据字段类型生成默认值占位符
const getDefaultValueByType = (fieldType: string): string => {
  fieldType = fieldType.toLowerCase()
  // 数字类型
  if (fieldType.includes('int') || fieldType.includes('number') || fieldType.includes('decimal') || fieldType.includes('float') || fieldType.includes('double')) {
    return '0'
  }
  // 日期类型
  else if (fieldType.includes('date') || fieldType.includes('datetime') || fieldType.includes('time')) {
    return "SYSDATE" // Oracle/SQLServer通用占位符，用户可自行替换
  }
  // 布尔类型
  else if (fieldType.includes('bit') || fieldType.includes('bool')) {
    return '0'
  }
  // 字符串类型（默认空字符串）
  else {
    return "''" // 单引号包裹的空字符串
  }
}

// 优化：生成Select脚本核心方法（对齐修复）
const generateSelectScript = async (tableName: string, cmInstance: Editor) => {
  if (!tableName || tableName.trim() === '') {
    f.warning('未选中表名，请先选中要生成查询的表名')
    return
  }

  try {
    const dbName = sqlEditForm.db_name || 'SYS'
    const tableStructParams = {
      apicode: 'S_Table_Struce',
      TabName: tableName.trim(),
      DBName: dbName
    }

    const tableData = await dm.value.data('/api/comm/data/', tableStructParams)
    if (!tableData || !tableData.data || !Array.isArray(tableData.data.list)) {
      f.warning(`未查询到表【${tableName}】的结构信息`)
      return
    }
    const dt = tableData.data.list

    // 1. 重新计算字段名的实际显示宽度（适配中文）
    let maxDisplayWidth = 0
    dt.forEach((dr: any) => {
      const fieldName = dr['列名'] || ''
      const displayWidth = getStringDisplayWidth(fieldName)
      maxDisplayWidth = Math.max(maxDisplayWidth, displayWidth)
    })
    // 2. 基准宽度：最大宽度 + 2（预留空格），最小30
    const baseWidth = Math.max(maxDisplayWidth + 2, 30)

    // 3. 拼接字段列表（精准对齐）
    let sFeilds = ''
    dt.forEach((dr: any) => {
      const fieldName = dr['列名'] || ''
      const cnName = dr['中文名'] || dr['列名'] || ''
      
      // 计算当前字段需要补充的空格数
      const currentWidth = getStringDisplayWidth(fieldName)
      const paddingCount = baseWidth - currentWidth
      // 生成填充的空格（不用\t，避免制表符宽度不一致）
      const padding = ' '.repeat(paddingCount > 0 ? paddingCount : 1)
      
      // 拼接字段行（字段名 + 填充空格 + 注释）
      const comment = cnName ? `-- ${cnName}` : ''
      sFeilds += `,${fieldName}${padding}${comment}\r\n`
    })
    if (sFeilds.length > 0) {
      sFeilds = sFeilds.trimStart(',')
    }

    // 4. 生成最终SQL（保持原有逻辑）
    let sSQL = ''
    const dbType = await getDbType(dbName)
    if (dbType === 'OracleServer') {
      sSQL = `\r\nSelect \r\n ${sFeilds} From ${tableName} \r\nWhere rownum<1000`
    } else {
      sSQL = `\r\nSelect TOP 1000 \r\n ${sFeilds} From ${tableName}`
    }

    // 5. 插入到编辑器
    cmInstance.replaceSelection(sSQL)
    cmInstance.setSelection(cmInstance.getCursor(), cmInstance.getCursor())
    cmInstance.refresh()

    f.success(`成功生成【${tableName}】的Select查询脚本（字段已对齐）`)
  } catch (error) {
    console.error('生成Select脚本失败：', error)
    f.error(`生成Select脚本失败：${(error as Error).message}`)
  }
}

const getDbType = async (dbName: string): Promise<string> => {
  try {
    const params = {
      apicode: 'S_Get_DbType',
      DBName: dbName
    }
    const dbTypeData = await dm.value.getValue('/api/comm/data/', params)
    return dbTypeData || 'SqlServer' // 默认返回SQLServer
  } catch (error) {
    console.error('获取数据库类型失败：', error)
    return 'SqlServer'
  }
}

const generateUpdateScript = async (tableName: string, cmInstance: Editor) => {
  if (!tableName || tableName.trim() === '') {
    f.warning('未选中表名，请先选中要生成更新的表名')
    return
  }

  try {
    const dbName = sqlEditForm.db_name || 'SYS'
    const tableStructParams = {
      apicode: 'S_Table_Struce',
      TabName: tableName.trim(),
      DBName: dbName
    }

    const tableData = await dm.value.data('/api/comm/data/', tableStructParams)
    if (!tableData || !tableData.data || !Array.isArray(tableData.data.list)) {
      f.warning(`未查询到表【${tableName}】的结构信息`)
      return
    }
    const dt = tableData.data.list

    // 复用Select逻辑：计算字段名最大显示宽度（适配中文字符）
    let maxDisplayWidth = 0
    dt.forEach((dr: any) => {
      const fieldName = dr['列名'] || ''
      maxDisplayWidth = Math.max(maxDisplayWidth, getStringDisplayWidth(fieldName))
    })
    const baseWidth = Math.max(maxDisplayWidth + 4, 30)

    // 拼接SET子句（复用Select/Insert的空格填充替代padRight）
    let sFeilds = ""
    dt.forEach((dr: any) => {
      const fieldName = dr['列名'] || ''
      let sCNName = dr['中文名']?.toString() || fieldName // 优先取中文名，无则取列名
      
      const currentWidth = getStringDisplayWidth(fieldName)
      const paddingCount = baseWidth - currentWidth
      const padding = ' '.repeat(paddingCount > 0 ? paddingCount : 1)
      
      const isCNNameEmpty = !sCNName || sCNName.trim() === ''
      const s1 = `{${isCNNameEmpty ? fieldName : sCNName}}`
      
      // 占位符对齐（复用相同的宽度计算）
      const s1CurrentWidth = getStringDisplayWidth(s1)
      const s1PaddingCount = baseWidth - s1CurrentWidth
      const s1Padding = ' '.repeat(s1PaddingCount > 0 ? s1PaddingCount : 1)
      
      // 注释拼接
      const comment = sCNName ? `--${sCNName}` : ''
      
      sFeilds += `,${fieldName}${padding}= ${s1}${s1Padding} ${comment}\r\n`
    })

    // 移除开头的逗号
    if (sFeilds.length > 0) {
      sFeilds = sFeilds.trimStart(',')
    } else {
      f.warning(`表【${tableName}】无可用字段`)
      return
    }

    const sSQL = `\r\nUPDATE ${tableName} \r\nSET \r\n ${sFeilds}WHERE <搜索条件,,>`

    // 插入到编辑器
    cmInstance.replaceSelection(sSQL)
    cmInstance.setSelection(cmInstance.getCursor(), cmInstance.getCursor())
    cmInstance.refresh()

  } catch (error) {
    console.error('生成Update脚本失败：', error)
    f.error(`生成Update脚本失败：${(error as Error).message}`)
  }
}

// ========== 1. 复刻C#枚举和核心变量 ==========
enum ParaType {
  Hide = 'Hide',     // # 隐藏参数
  Readonly = 'Readonly', // @ 只读参数
  Where = 'Where',   // $ 条件参数
  Normal = 'Normal'  // 普通参数
}

// 复刻C#的全局变量（解析结果存储）
const analysisResult = reactive({
  Dict: {} as Record<string, ParaType>, // {参数标识: 类型} 如 {"{#hide}": ParaType.Hide}
  NameDict: {} as Record<string, ParaType>, // {参数名: 类型} 如 {"#hide": ParaType.Hide}
  List: [] as string[], // 参数标识列表 如 ["{#hide}", "{@read}"]
  NameList: [] as string[], // 参数名列表 如 ["#hide", "@read"]
  FormDict: {} as Record<string, string>, // /*窗口参数*/解析结果 如 {"title": "订单列表"}
  FormList: [] as string[], // 窗口参数名列表
  haveHidePara: false, // 是否包含隐藏参数
  haveReadOnlyPara: false // 是否包含只读参数
});

// 生成执行脚本（极简版：单参数exec调用，仅接收SQL和itemCode）
// 修复后的生成执行脚本函数
const generateExecScript = (SQL: string, itemCode: string) => {
  // 前置空值校验
  if (!SQL || typeof SQL !== 'string') {
    f.warning('SQL脚本不能为空！');
    return '';
  }
  if (!itemCode) {
    f.warning('ItemCode不能为空！');
    return '';
  }

  // 解析SQL中的参数
  AnalysisSQLScript(SQL);

  // 核心修复2：获取所有参数名（去重+去前缀）
  const paramNames = analysisResult.NameList.filter(name => name); // 过滤空值

  // 生成参数对象（核心修复3：遍历所有参数，而非仅第一个）
  const cmdList: string[] = [];
  cmdList.push('');
  cmdList.push('const params = {');
  cmdList.push(`  apicode: '${itemCode}',`);
  
  // 修复4：遍历所有参数生成空值占位
  if (paramNames.length > 0) {
    paramNames.forEach(param => {
      cmdList.push(`  ${param}: '',`); // 每个参数都生成空值占位
    });
  }
  cmdList.push('};');
  cmdList.push('');
  cmdList.push('// 执行接口调用');
  cmdList.push('const success = await dm.value.exec(\'/api/comm/exec/\', params);');
  cmdList.push('if (success) {');
  cmdList.push('  console.log(`执行成功`);');
  cmdList.push('} else {');
  cmdList.push('  console.warn(`执行失败`);');
  cmdList.push('}');

  // 拼接最终代码（统一缩进）
  const finalCode = cmdList.join('\r\n  ');

  // 复制到剪贴板（带错误处理）
  try {
    navigator.clipboard.writeText(finalCode)
      .then(() => {
        message.success('执行脚本已生成并复制到剪贴板！');
        console.log('生成的执行脚本：\n', finalCode);
      });
  } catch (err) {
    // 降级方案
    const textArea = document.createElement('textarea');
    textArea.value = finalCode;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand('copy');
    document.body.removeChild(textArea);
    message.success('执行脚本已复制（降级方案）！');
  }

  return finalCode;
};
// 完整修复后的 AnalysisSQLScript 方法
// 修复后的SQL解析函数
const AnalysisSQLScript = (SQL: string | undefined | null) => {
  // 1. 初始化解析结果（必写，防止未定义）
  const init = () => {
    analysisResult.Dict = {};
    analysisResult.NameDict = {};
    analysisResult.List = [];
    analysisResult.NameList = [];
    analysisResult.FormDict = {};
    analysisResult.FormList = [];
    analysisResult.haveHidePara = false;
    analysisResult.haveReadOnlyPara = false;
  };

  // 2. 空值校验：如果SQL为空，直接初始化并返回
  if (!SQL || typeof SQL !== 'string') {
    init();
    return;
  }

  // 3. 初始化解析结果
  init();

  // 4. 解析/*窗口参数*/（修复 indexOf 报错 + 变量定义）
  const formIndexOf = SQL.indexOf("/*");
  if (formIndexOf > -1) {
    const s2 = SQL;
    const pattern2 = /\/\*[\s\S]*?\*\//g;
    const match1 = s2.match(pattern2) || [];
    const ls: string[] = [];
    
    match1.forEach(matchStr => {
      let s21 = matchStr.trimStart().replace(/^\/\*/, '');
      s21 = s21.trimEnd().replace(/\*\//, '');
      const splitList = s21.replace(/\r\n/g, '').split(';').filter(item => item);
      ls.push(...splitList);
    });
    
    const map: Record<string, string> = {};
    ls.forEach(s => {
      const kv = s.split('=');
      if (kv.length > 1 && !map[kv[0]]) {
        map[kv[0]] = kv[0];
        analysisResult.FormDict[kv[0]] = kv[1] || '';
        analysisResult.FormList.push(kv[0]);
      }
    });
  }

  // 5. 解析{参数}（核心修复：适配纯占位符 + 完整遍历）
  const pattern = /\{([^}]+)\}/g; // 匹配 {任意内容}
  const matches = SQL.matchAll(pattern);
  
  // 修复：遍历所有匹配结果，不跳过有效参数
  for (const match of matches) {
    if (!match || match.length < 2) continue;
    
    const fullMatch = match[0]; // {UserCode}
    let paramName = match[1]; // UserCode
    
    // 核心修复1：移除所有前缀（#/@/$），保留纯参数名
    paramName = paramName.replace(/^[#@$]/, '').trim();
    if (!paramName) continue; // 空参数名直接跳过
    
    if (!analysisResult.List.includes(fullMatch)) {
      // 判断参数类型（兼容无前缀的普通参数）
      let type: ParaType = ParaType.Normal;
      if (match[1].startsWith('#')) type = ParaType.Hide;
      else if (match[1].startsWith('@')) type = ParaType.Readonly;
      else if (match[1].startsWith('$')) type = ParaType.Where;
      
      // 填充解析结果（用处理后的纯参数名）
      analysisResult.Dict[fullMatch] = type;
      analysisResult.NameDict[paramName] = type;
      analysisResult.List.push(fullMatch);
      // 去重：避免重复添加相同参数名
      if (!analysisResult.NameList.includes(paramName)) {
        analysisResult.NameList.push(paramName);
      }
      
      // 更新参数类型标记
      if (type === ParaType.Hide) analysisResult.haveHidePara = true;
      if (type === ParaType.Readonly) analysisResult.haveReadOnlyPara = true;
    }
  }
};


// 改造后的入参版方法（完全匹配预期输出）
const generateAntdDsScript = (SQL: string, itemCode: string) => {
  AnalysisSQLScript(SQL);

  const cmdList: string[] = [];
  
  cmdList.push(`try {`);
  
  cmdList.push(`  const params = {`);
  cmdList.push(`    apicode: '${itemCode}',`); // 核心apicode
  
  if (analysisResult.List.length > 0) {
    Object.keys(analysisResult.NameDict).forEach(name => {
      const pureName = name.replace(/^[#@$]/, '');
      cmdList.push(`    ${pureName}: '',`);
    });
  }
  if (Object.keys(analysisResult.FormDict).length > 0) {
    Object.entries(analysisResult.FormDict).forEach(([key, value]) => {
      cmdList.push(`    ${key}: '${value}',`);
    });
  }
  
  cmdList.push(`  };`);
  cmdList.push(``);
  
  cmdList.push(`  const data = await dm.value.data('/api/comm/data/', params);`);
  cmdList.push(``);
  
  cmdList.push(`  //return data?.data?.list?.map((item: any) => ({      value: item.CODE,      label: item.NAME    })) || [];`);
  
  cmdList.push(`} catch (error) {`);
  cmdList.push(`  console.error(\`获取数据失败:\`, error);`);
  cmdList.push(`  f.error(\`获取数据失败\`);`);
  cmdList.push(`  return [];`);
  cmdList.push(`}`);

  const finalCode = cmdList.join('\r\n  ');
  
  navigator.clipboard.writeText(finalCode)
    .then(() => {
      message.success('代码已生成并复制到剪贴板！');
    })
    .catch(() => {
      const textArea = document.createElement('textarea');
      textArea.value = finalCode;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      message.success('代码已复制（降级方案）！');
    });
};
const handleContextMenuClick3 = async (key: string) => {
  if (!isSqlCmReady.value) {
    f.warning('SQL编辑器尚未初始化完成，请稍后重试')
    return
  }

  // 前置校验2：获取编辑器实例（兼容多种获取方式）
  let cmInstance: Editor | null = null
  // 方式1：从 ref 获取（优先）
  if (sqlCmRef1.value?.cm) {
    cmInstance = sqlCmRef1.value.cm
  } 
  // 方式2：从全局实例获取（兜底）
  else if (sqlCmInstance.value) {
    cmInstance = sqlCmInstance.value
  }
  // 方式3：通过 DOM ID 获取（终极兜底）
  else {
    const cmDom = document.getElementById('cm_sql_editor')
    if (cmDom && (window as any).CodeMirror) {
      cmInstance = (window as any).CodeMirror.fromTextArea(cmDom.querySelector('textarea')!)
    }
  }

  // 最终校验：实例是否存在
  if (!cmInstance) {
    f.warning('未获取到SQL编辑器实例，请刷新页面重试')
    return
  }

  // 剪切/复制校验：是否有选中内容
  if (['cut', 'copy'].includes(key) && !cmInstance.getSelection()) {
    // f.warning('未选中任何SQL文本，请先选中内容再操作')
    const fullContent = cmInstance.getValue(); // 核心：获取编辑器所有文本（不依赖选区）
// 复制全部内容到剪贴板（传入完整内容，提示文案对应调整）
    copyToClipboard(fullContent, '全部SQL内容', '已复制全部SQL内容到剪贴板');
    return
  }

  // 非编辑器操作（如 run/load_item）校验 currentRow
  // if (!currentRow.value && !['cut', 'copy', 'paste', 'find_replace'].includes(key)) {
  //   f.warning('未获取到当前行数据')
  //   return
  // }

  // 解构当前行数据（非编辑器操作需用到）
  const { ItemCode, ItemName, SQLScript } = currentRow.value || {}

  switch (key) {
    // 第一组：剪切/复制/粘贴（你替换后的逻辑）
    case 'cut':
      const cutContent = cmInstance.getSelection()
      copyToClipboard(cutContent, '选中内容', '剪切选中内容成功！')
      cmInstance.replaceSelection('')
      // f.success('已剪切选中的SQL文本到剪贴板')
      break
    case 'copy':
      const copyContent = cmInstance.getSelection()
      copyToClipboard(copyContent, '选中内容')
      // f.success('已复制选中的SQL文本到剪贴板')
      break
    case 'paste':
      navigator.clipboard.readText().then((pasteContent) => {
        if (pasteContent) {
          cmInstance.replaceSelection(pasteContent)
          // f.success('已将剪贴板内容粘贴到SQL编辑器')
        } else {
          f.warning('剪贴板为空，无法粘贴')
        }
      }).catch(() => {
        f.error('粘贴失败，浏览器不允许访问剪贴板')
      })
      break

    // 第二组：编写脚本子菜单
    case 'create_select':
      const selectedTableName = cmInstance.getSelection()
      // 调用生成Select脚本方法
      await generateSelectScript(selectedTableName, cmInstance)
      break
    case 'create_update':
      const updateTableName = cmInstance.getSelection()
      await generateUpdateScript(updateTableName, cmInstance)
      break
    case 'create_insert':
      const insertTableName = cmInstance.getSelection()
      // 调用生成Select脚本方法
      await generateInsertScript (insertTableName, cmInstance)
      break

    // 第三组：系统变量子菜单（插入到编辑器）
    case 'user_id':
      cmInstance.replaceSelection('{USERID}')
      f.success('已插入「用户ID」系统变量')
      break
    case 'user_name':
      cmInstance.replaceSelection('{USERNAME}')
      f.success('已插入「用户名」系统变量')
      break
    case 'role':
      cmInstance.replaceSelection('{USERROLE}')
      f.success('已插入「权限组」系统变量')
      break
    case 'pc_name':
      cmInstance.replaceSelection('${PCName}')
      f.success('已插入「主机名」系统变量')
      break
    case 'pc_ip':
      cmInstance.replaceSelection('{HOSTNAME}')
      f.success('已插入「主机IP」系统变量')
      break

    // 第四组：条件管理子菜单
    case 'add_where':
      f.info(`为${ItemCode}添加查询条件（需补充条件添加逻辑）`)
      // openAddWhereModal(ItemCode, cmInstance)
      break
    case 'edit_where':
      f.info(`编辑${ItemCode}的查询条件（需补充条件编辑逻辑）`)
      // openEditWhereModal(ItemCode, cmInstance)
      break
    case 'clone_where':
      f.info(`克隆${ItemCode}的查询条件（需补充条件克隆逻辑）`)
      // cloneWhereCondition(ItemCode, cmInstance)
      break
    case 'delete_where':
      f.info(`删除${ItemCode}的查询条件（需补充条件删除逻辑）`)
      // deleteWhereCondition(ItemCode, cmInstance)
      break
    case 'view_condition_list':
      f.info(`查看${ItemCode}的查询条件列表（需补充列表展示逻辑）`)
      // openConditionListModal(ItemCode)
      break

    // 第五组：插入代码段子菜单
    case 'return_message':
      const returnMsgTemplate = `      -- 返回消息定义
      DECLARE @Result INT = 0
      DECLARE @Msg NVARCHAR(500) = '操作成功'
      SELECT @Result AS Result, @Msg AS Msg`
      cmInstance.replaceSelection(returnMsgTemplate)
      f.success('已插入「返回消息定义」代码段')
      break
    case 'dialog_param':
      const dialogParamTemplate = `      -- 对话框参数
      DECLARE @Param1 NVARCHAR(50) = '' -- 参数1
      DECLARE @Param2 INT = 0 -- 参数2`
      cmInstance.replaceSelection(dialogParamTemplate)
      f.success('已插入「对话框参数」代码段')
      break
    case 'find_more_snippet':
      openSqlHelpModal.value = true
      break

    // 第七组：查找和替换
    case 'find_replace':
      showFindReplace.value = true
      
      // cmInstance.execCommand('find')
      // f.info('打开查找和替换面板')
      break

    // 保留原菜单逻辑
    // case 'run':
    //   sqlExecuteModal.itemCode = ItemCode
    //   sqlExecuteModal.isVisible = true
    //   break

    // case 'runscript1':
    // // 前置校验
    //   if (!currentRow.value) {
    //     f.warning('请先选择表格中的脚本行！');
    //     return;
    //   }
    //   // 直接调用已封装的生成方法
    //   generateExecScript(currentRow.value.SQScript,currentRow.value.Itemcode);
    //   break      
    // case 'runscript2':
    //    f.warning('请先选择表格中的脚本行！');
    //   //获取脚本数据集
    // // 前置校验
    //   if (!currentRow.value) {
    //     f.warning('请先选择表格中的脚本行！');
    //     return;
    //   }
    //   // 直接调用已封装的生成方法
    //   generateAntdDsScript(currentRow.value.SQScript,currentRow.value.Itemcode);
    //   break
    // case 'load_item':
    //   try {
    //     const loadParams = { itemCode: ItemCode }
    //     const loadData = await dm.value.data('/api/comm/load_item/', loadParams)
    //     console.log('load_item', loadData)
    //     if (loadData?.status === 0) {
    //       f.success(`后台重载${ItemCode}成功！`)
    //     } else {
    //       f.error(`${ItemCode} 缓存同步返回异常：失败！`)
    //     }
    //   } catch (loadError) {
    //     f.error(`缓存同步失败 ${ItemCode} ！`)
    //   }
    //   break

    // 默认情况
    default:
      f.info(`暂未实现「${key}」操作的逻辑`)
      break
  }
}

// 辅助方法（需保留）
// const openCodeSnippetModal = (cmInstance: Editor) => {
//   // 示例：打开代码段弹窗，选择后插入到编辑器
//   // codeSnippetModal.isVisible = true
//   // codeSnippetModal.cmInstance = cmInstance
//   f.info('代码段选择面板功能待实现')
// }
// 4. 优化右键菜单触发逻辑，确保编辑器已渲染
// 优化右键菜单触发逻辑，适配全屏状态
const handleEditorContextMenu = (e: MouseEvent) => {
  e.preventDefault() 
  
  if (!isSqlCmReady.value) {
    f.warning('编辑器尚未就绪，暂无法使用右键菜单')
    return
  }

  const isFullScreen = screenfull.isEnabled && screenfull.isFullscreen
  const fullscreenElement = screenfull.element as HTMLElement | null
  const cmDom = document.getElementById('cm_sql_editor')

  // -------- 修复：增加像素容错 + 强制行高刷新 --------
  if (isFullScreen) {
    const safeHeight = 'calc(100vh - 110px)' // 从100px→110px，增加10px容错
    if (cmDom) {
      cmDom.style.height = safeHeight
      cmDom.style.minHeight = safeHeight
      cmDom.style.maxHeight = safeHeight // 新增：锁定最大高度
    }
    if (sqlCmInstance.value) {
      sqlCmInstance.value.setSize('100%', safeHeight)
      // 强制刷新行高（关键：修复行截断）
      sqlCmInstance.value.refresh()
      sqlCmInstance.value.display.wrapper.style.height = safeHeight
      sqlCmInstance.value.display.scroller.style.height = '100%'
    }
  }
  // -------------------------------------------------------

  if (isFullScreen && fullscreenElement) {
    const fullscreenRect = fullscreenElement.getBoundingClientRect()
    // 修复：菜单坐标偏移 +5px，避免遮挡编辑器边缘
    contextMenuX.value = e.clientX - fullscreenRect.left + 5
    contextMenuY.value = e.clientY - fullscreenRect.top + 5
  } else {
    const wrapperEl = editorWrapper.value
    if (wrapperEl) {
      const rect = wrapperEl.getBoundingClientRect()
      const borderOffsetX = -40
      const borderOffsetY = -163
      const scrollOffsetX = wrapperEl.scrollLeft
      const scrollOffsetY = wrapperEl.scrollTop

      contextMenuX.value = e.clientX - rect.left - borderOffsetX + scrollOffsetX
      contextMenuY.value = e.clientY - rect.top - borderOffsetY + scrollOffsetY
    } else {
      contextMenuX.value = e.clientX
      contextMenuY.value = e.clientY
    }
  }

  isContextMenuShow.value = true
}

const contextMenuItems2: ContextMenuItem[] = [
  // 第一组：剪切/复制/粘贴
  { key: 'cut', label: ' 剪切'},
  { key: 'copy', label: ' 复制'},
  { key: 'paste', label: ' 粘贴'},
  { key: 'sep1', label: '---' }, // 补全key

  // 第二组：编写脚本（子菜单）
  {
    key: 'create_code',
    label: '编写脚本',
    children: [
      { key: 'create_select', label: 'Select' },
      { key: 'create_update', label: 'Update' },
      { key: 'create_insert', label: 'Insert' },
    ]
  },

  {
    key: 'system_var',
    label: '系统变量',
    children: [
      { key: 'user_id', label: '用户ID' },
      { key: 'user_name', label: '用户名' },
      { key: 'role', label: '权限组' },
      { key: 'pc_name', label: '主机名' },
      { key: 'pc_ip', label: '主机IP' }
    ]
  },
  {
    key: 'insert_code_snippet',
    label: '插入代码段',
    children: [
      { key: 'return_message', label: '返回消息定义' },
      { key: 'dialog_param', label: '对话框参数' },
      { key: 'find_more_snippet', label: '查找更多片段'}
    ]
  },
  { key: 'sep6', label: '---' }, 
  { 
    key: 'find_replace', 
    label: '查找和替换', 
  }
];

// 类型补充（解决CSSProperties报错）
interface CSSProperties extends React.CSSProperties {}
</script>
<style scoped>
@import '@/style/index.less';

/* 父容器的 Flex 布局样式 */
.counter-group {
  display: flex;
  gap: 20px;
  justify-content: center;
  align-items: stretch;
  padding: 20px;
  flex-wrap: wrap;
}

.example-container {
  margin: 0px;
  padding: 0px;
}

/* 自定义按钮样式 */
.custom-btn {
  padding: 4px 12px;
  background-color: #42b983;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

/* 状态文本样式 */
.status-text {
  color: #666;
  font-size: 14px;
}

.colorful-icon {
  color: #52c41a !important;
  font-size: 14px !important;
}

/* 表格样式 */
:deep(.ant-table-tbody > tr:nth-child(odd)) {
  background-color: #fafafa;
}

:deep(.ant-table-tbody > tr:nth-child(even)) {
  background-color: #ffffff;
}

:deep(.ant-table-tbody > tr:hover > td) {
  background-color: #e6f7ff !important;
}

:deep(.ant-table-tbody > tr > td),
:deep(.ant-table-thead > tr > th) {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  box-sizing: border-box;
}

:deep(.ant-table-header),
:deep(.ant-table-body) {
  table-layout: fixed !important;
}

/* 编辑器容器 */
.editor-container {
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  overflow: hidden;
}

/* 强制高亮样式（优先级最高） */
/* 基础样式（通用） */
:deep(.CodeMirror) {
  /* 调整字体优先级：macOS 优先用 SF Mono（苹果原生等宽字体），Windows 用 Consolas */
  font-family: 
    SF Mono,         /* macOS 现代原生等宽字体（最佳选择） */
    Consolas,        /* Windows SSMS 标配等宽字体 */
    Menlo,           /* macOS 备选 */
    Monaco,          /* macOS 旧版/部分Linux 备选 */
    'Courier New',   /* 全平台通用兜底 */
    monospace !important;
  
  /* 基础字号：Windows 14px，macOS 12px（视觉等效） */
  font-size: 14px !important;
  
  /* 字体渲染优化 */
  font-weight: 400 !important;
  letter-spacing: 0px !important;
  line-height: 1.4 !important; /* 提升行高适配小字号 */
  -webkit-font-smoothing: subpixel-antialiased !important; /* macOS 更清晰的渲染模式 */
  -moz-osx-font-smoothing: auto !important;
  text-size-adjust: 100% !important;
  -webkit-text-size-adjust: 100% !important;
  
  /* 背景色 */
  background: #ffffff !important;
}
/* 针对 macOS 系统的专属适配（关键） */
@media (prefers-color-scheme: light) and (os-version: mac) {
  :deep(.CodeMirror) {
    font-size: 12px !important; /* macOS 视觉等效 14px 的实际字号 */
    letter-spacing: -0.2px !important; /* 轻微收紧字间距，适配macOS字体 */
    font-smooth: always !important;
  }
}

/* CodeMirror 语法高亮颜色 */
/* 原有：基础关键字（蓝色） */
:deep(.cm-keyword) {
  color: #0000ff !important;
  font-weight: 400 !important;
  /* font-weight: bold !important; */
}
/* 关键新增：日期函数（红色） */
:deep(.cm-date-function) {
  color: #ff00ff !important; /* 红色高亮日期函数 */
  font-weight: 400 !important;
  /* font-weight: bold !important; */
}
/* 原有样式保留 */
:deep(.cm-string) {
  color: #ff0000 !important;
  font-weight: 400 !important;
}
:deep(.cm-comment) {
  color: #008000 !important;
  font-weight: 400 !important;
}
:deep(.cm-number) {
  color: #333333 !important;
  font-weight: 400 !important;
}
:deep(.cm-variable) {
  color: #333333 !important;
  font-weight: 400 !important;
}


/* 编辑器基础样式 */


/* SQL编辑弹窗样式 */
.sql-modal-content {
  width: 100%;
  box-sizing: border-box;
  /* padding: 16px; */
}
.tool-icon {
  font-size: 14px !important;
  color: rgba(0, 0, 0, 0.65);
}
:deep(.ant-modal-body) {
  padding: 0 !important;
  overflow: visible !important;
}
#cm_sql_editor {
  border: 1px solid #d9d9d9 !important;
  border-radius: 2px;
  transition: height 0.3s ease;
}
.screenfull-enabled #cm_sql_editor {
  border: none !important;
  border-radius: 0 !important;
}

:deep(.ant-table-tbody > tr > td),
:deep(.ant-table-tbody > tr > td *) {
  cursor: default !important; /* 恢复默认箭头光标，消除I型 */
}

:deep(.CodeMirror-line) {
  padding-left: 8px !important;          /* 无额外内边距 */
  line-height: inherit !important; /* 继承编辑器行高 */
  vertical-align: baseline !important; /* 基线对齐，避免 macOS 文字偏上 */
}

/* 全屏时内容容器样式 */
:deep(.screenfull-enabled .sql-modal-content) {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  z-index: 9999 !important;
  background: #fff !important;
  padding: 20px !important;
  overflow: auto !important;
}




/* 全屏时模态框标题栏置顶 */
:deep(.screenfull-enabled .ant-modal-header) {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  z-index: 10000 !important;
  background: #fff !important;
  border-bottom: 1px solid #e8e8e8 !important;
  padding: 16px 24px !important;
}

/* 全屏时编辑器容器自适应 */
:deep(.screenfull-enabled #cm_sql_editor) {
  height: calc(100vh - 120px) !important;
  border: none !important;
  border-radius: 0 !important;
}

/* 全屏时模态框body无内边距 */
:deep(.screenfull-enabled .ant-modal-body) {
  padding-top: 60px !important; /* 避开标题栏 */
  height: 100vh !important;
  overflow: hidden !important;
}

/* :deep(.screenfull) {
  background: #ffffff !important;
}
:deep(.screenfull > div) {
  background: #ffffff !important;
} */

.context-menu {
  opacity: 1;
  transition: opacity 0.05s ease;
  pointer-events: auto;
}
.context-menu[style*="display: none"] {
  opacity: 0 !important;
  pointer-events: none !important;
  height: 0 !important;
  width: 0 !important;
  overflow: hidden !important;
  /* 关键：不删除 DOM，仅隐藏，避免重排 */
}
</style>


<style>
.find-replace-modal {
  position: absolute !important; /* 相对于编辑器容器定位 */
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  z-index: 9999 !important; /* 容器内最高层级，覆盖编辑器 */
  pointer-events: none !important; /* 不拦截编辑器交互 */
}
/* 可选：浏览器原生全屏根元素背景（仅根元素） */
:fullscreen {
  background: #ffffff !important;
}
:-webkit-full-screen {
  background: #ffffff !important;
}
:-moz-full-screen {
  background: #ffffff !important;
}

:deep(.sql-modal-content:fullscreen) {
  background: #ffffff !important;
}
</style>